// 2024-10-07T09:50:15.542Z  (1728294615542)
export const locale = {
	lang: 'pt',
	data: {
		'ACCOUNTING_VALUE': 'Valor contabilístico',
		'ACCOUNTING_VALUE.COMPUTE_IN_STATES': 'Cálculo apenas em estados de trabalho selecionados',
		'ACCOUNTING_VALUE.VALUE_AGGREGATION': 'Agregação de valores',
		'ACCOUNTING_VALUE.VALUE_COMPUTATION': 'Cálculo de valores',
		'ACCOUNTING_VALUE.VALUE_SUMMATION': 'Soma de valores',
		'ACCOUNT_ACTIVATION': 'Ativação da conta',
		'ACCOUNT_ACTIVATION.CODE': 'Código de ativação',
		'ACCOUNT_ACTIVATION.CODE.RESEND': 'Reenviar código de ativação',
		'ACCOUNT_ACTIVATION.INTRO': 'Por favor preencha com o código de ativação recebido no email',
		'ACID': 'Acid',
		'ACTIVATE': 'Ativar',
		'ACTIVATE.SELECTED': 'Ativar selecionado',
		'ACTIVE': 'Ativo',
		'ACTIVITIES.DAILY': 'Atividades diárias',
		'ACTIVITIES.EXPORT': 'Exportar actividades',
		'ACTIVITIES.NO': 'Sem atividades',
		'ACTIVITIES.WEEKLY': 'Atividades semanais',
		'ACTIVITY': 'Atividade',
		'ACTIVITY.EXPORT_DETAILS': 'Exportação da actividade seleccionada',
		'ACTIVITY.NO_FIELDS_WORKED': 'Nenhum campo foi trabalhado',
		'ADAPTER': 'Adaptador',
		'ADAPTER.ASSIGN': 'Escolha um adaptador',
		'ADAPTER.ASSIGN.FAILURE': 'Houve um erro ao ligar o adaptador',
		'ADAPTER.ASSIGN.SUCCESS': 'Adaptador atribuído com sucesso',
		'ADAPTER.ASSIGNED_MACHINE': 'Máquina atribuída',
		'ADAPTER.ASSIGNMENT': 'Atribuir adaptador à máquina',
		'ADAPTER.CHOSEN': 'Adaptador selecionado',
		'ADAPTER.LOAD.FAILURE': 'Houve um erro ao carregar o adaptador',
		'ADAPTER.NO': 'Nenhum adaptador',
		'ADAPTER.NONE_AVAILABLE': 'Nenhum adaptador disponível',
		'ADAPTER.PAIR_INFO': 'Selecione o adaptador apropriado. Os adaptadores já atribuídos serão atualizados com a nova máquina. A nova configuração do adaptador será carregada automaticamente na próxima vez que o mesmo for iniciado.',
		'ADAPTER.PREVIOUS': 'Adaptador anterior',
		'ADAPTERS.NO': 'Nenhum adaptador',
		'ADBLUE.LEVEL': 'Nível do AdBlue',
		'ADD': 'Adicionar',
		'ADDITIONAL_VALUE': 'Valor adicional',
		'ADDITIVE': 'Aditivo',
		'ADDRESS': 'Endereço',
		'ALL': 'Todos',
		'ALL_DEVICES': 'Todos os adaptadores',
		'AMOUNT': 'Quantidade',
		'AMOUNT.INVALID': 'Quantidade inválida',
		'AMOUNTS': 'Quantidades',
		'APPLY': 'Aplicar',
		'ARCHIVE': 'Arquivar',
		'ARCHIVE.SELECTED': 'Arquivar selecionado',
		'AREA': 'Área',
		'AREA.FIELD': 'Area',
		'AREA.LOCATION': 'Localizações de áreas',
		'AREA.PERFORMANCE': 'Flächenleistung',
		'AREA.PROCESSED': 'Area trabalhada',
		'AREA.TOTAL': 'Area total',
		'AREA.WORKED': 'Área trabalhada',
		'ASSIGN': 'Atribuir',
		'AUTH.REMEMBER_ME': 'Lembrar-me',
		'BACK': 'Voltar',
		'BALES': 'Bales',
		'BASIC_DATA': 'Dados básicos',
		'BEACON': 'Beacon',
		'BEACON.ASSIGN': 'Escolha um beacon',
		'BEACON.ASSIGN.SUCCESS': 'Beacon atribuído com sucesso',
		'BEACON.ASSIGNED_EMPLOYEE': 'Funcionário designado',
		'BEACON.ASSIGNED_IMPLEMENT': 'Alfaia atribuído',
		'BEACON.ASSIGN_TO_EMPLOYEE': 'Atribuir Beacon aos funcionários',
		'BEACON.ASSIGN_TO_IMPLEMENT': 'Atribuir beacon ao alfaia',
		'BEACON.CHOSEN': 'Beacon selecionado',
		'BEACON.ERROR': 'Houve um erro ao ligar o Beacon',
		'BEACON.LOAD_ERROR': 'Houve um erro ao carregar o Beacon',
		'BEACON.NONE_AVAILABLE': 'Nenhum Beacon disponível',
		'BEACON.NO_BEACON': 'Nenhum Beacon',
		'BEACON.PAIR_INFO_EMPLOYEE': 'Selecione o Beacon apropriado. Os Beacons já atribuídos serão atualizados com o novo funcionário.',
		'BEACON.PAIR_INFO_IMPLEMENT': 'Selecione o beacon apropriado. Os beacons já atribuídos serão atualizados com a nova alfaia.',
		'BEACON.PREVIOUS': 'Beacon anterior',
		'BEACONS': 'Beacons',
		'BUILD_YEAR': 'Ano de Fabricação',
		'BUILD_YEAR.INVALID': 'Ano de fabricação inválido',
		'CAN.STATUS': 'Situação CAN',
		'CANCEL': 'Cancelar',
		'CHANGE': 'Alterar',
		'CHANGE.NO': 'Sem mudanças',
		'CHOOSE_ALL': 'Selecionar tudo',
		'CHOOSE_ROLE': 'Por favor, selecione uma função',
		'CHRONOLOGICAL': 'Ordem cronológica',
		'CLICK_PROCESS': 'Selecione um processo para mais detalhes',
		'CLOSE': 'Fechar',
		'CO2.EMISSION': 'Emissões de CO2',
		'CO2.PER': 'CO2 por hectare',
		'CO2.TOTAL': 'Quantidade total de CO2',
		'COLOR': 'Cor',
		'COMMENT': 'Comentário',
		'CONDITION': 'Condição',
		'CONFIRM': 'Confirmar',
		'CONFIRM_PASSWORD': 'Confirmar senha',
		'CONNECT': 'Conectar',
		'CONTACT_PERSON': 'Pessoa para contato',
		'CONTINUE': 'Continuar',
		'COST': 'Custo',
		'COST.INVALID': 'Custo inválido',
		'COST.OVERALL': 'Custo total',
		'COST.OVERALL.ARRIVAL': 'Custo total de chegada',
		'COST.OVERALL.DRIVER': 'Custo total do motorista',
		'COST.OVERALL.FIELD_TIME': 'Custo total do campo',
		'COST.OVERALL.IMPLEMENTS': 'Custo global de alfaias',
		'COST.OVERALL.MACHINES': 'Custo global das máquinas',
		'COST.OVERALL.PREPARATION': 'Custo global da preparação',
		'COST.TOTAL': 'Custo total',
		'COSTS': 'Custos',
		'COST_RATE': 'Taxa de custos',
		'COUNTRY': 'País',
		'COVERAGE': 'Coverage',
		'COVERAGE.MAP': 'Mapa de cobertura',
		'COVERAGE.MAP.SETTINGS': 'Configurações do mapa de cobertura',
		'COVERAGE.MAP.ZONES': 'Zonas',
		'CREATED': 'Criado',
		'CREATE_USER': 'Criar usuário',
		'CROP.TYPE': 'Tipo de plantio',
		'CROP.NO_CROP': 'Sem cultura',
		'CURRENCY': 'Moeda',
		'CUSTOMER': 'Cliente',
		'CUSTOMER.ADD': 'Adicionar clientes',
		'CUSTOMER.ADD.SUCCESS': 'Cliente adicionado com sucesso',
		'CUSTOMER.ASSIGN': 'Atribuir cliente',
		'CUSTOMER.DELETE.QUESTION': 'Deseja realmente remover o cliente?',
		'CUSTOMER.DELETE.SUCCESS': 'Cliente removido com sucesso',
		'CUSTOMER.DETAILS': 'Detalhes do cliente',
		'CUSTOMER.EDIT': 'Editar cliente',
		'CUSTOMER.EDIT.SUCCESS': 'Cliente editado com sucesso',
		'CUSTOMER.NAME': 'Nome do cliente',
		'CUSTOMER.NO': 'Por favor, selecione um cliente primeiro!',
		'CUSTOMER.NOT_SELECTED': 'Nenhum cliente selecionado',
    'CUSTOMER.NO.ASSIGNEE': 'Nenhum cliente atribuído',
		'CUSTOMER.SELECT': 'Selecionar cliente',
		'CUSTOMERS': 'Clientes',
		'CUSTOMERS.ALL': 'Todos os clientes',
		'CUSTOMERS.DELETE.FAILURE': 'Alguns clientes não puderam ser excluídos',
		'CUSTOMERS.DELETE.QUESTION': 'Você quer excluir os clientes selecionados?',
		'CUSTOMERS.DELETE.SUCCESS': 'Clientes excluídos com sucesso',
		'CUSTOMERS.MANAGEMENT': 'Gestão de clientes',
		'CUSTOMERS.NO': 'Sem clientes',
		'CUSTOMERS.SELECTED': 'Clientes selecionados',
		'CUSTOM_LABELING': 'Rótulo personalizado',
		'CUSTOM_LABELING.ADD_WORKSTATE': 'Adicionar novo estado de trabalho',
		'CUSTOM_LABELING.DEFINE_FOR_IMPLEMENT': 'Defina um rótulo personalizado para a alfaia selecionada',
		'CUSTOM_LABELING.DEFINE_INDIVIDUAL_CONDITION': 'Defina condições individuais para o rótulo',
		'CUSTOM_LABELING.EDIT.SUCCESS': 'Rótulo personalizado editado com sucesso',
		'CUSTOM_LABELING.INDIVIDUAL_CONDITION': 'Condição individual',
		'CUSTOM_LABELING.ISOBUS_OVERRIDE': 'Permitir a anulação com condições ISOBUS',
		'CUSTOM_LABELING.NO_LABELS_AVAILABLE': 'Nenhum rótulo disponível',
		'DASHBOARD.GPS_DATA.NO': 'Sem dados de GPS',
		'DASHBOARD.MACHINE_POSITIONS.LOAD.FAILURE': 'Houve um erro ao carregar as posições da máquina',
		'DATA': 'Data',
		'DATA.ARCHIVED.WARNING': 'Os dados subjacentes estão parcial ou totalmente arquivados',
		'DATA.EXPORT': 'Exportar dados',
		'DATA.INPUT': 'Data input',
		'DATA.UPDATING.WARNING': 'Os dados subjacentes estão sendo atualizados',
		'DATA_PREPARATION': 'Preparação dos dados',
		'DATE': 'Data',
		'DATE.APRIL': 'Abril',
		'DATE.AUGUST': 'Agosto',
		'DATE.DECEMBER': 'Dezembro',
		'DATE.FEBRUARY': 'Fevereiro',
		'DATE.FRIDAY': 'Sexta-feira',
		'DATE.FROM': 'A partir de (Data)',
		'DATE.JANUARY': 'Janeiro',
		'DATE.JULY': 'Julho',
		'DATE.JUNE': 'Junho',
		'DATE.MARCH': 'Março',
		'DATE.MAY': 'Maio',
		'DATE.MONDAY': 'Segunda-feira',
		'DATE.NOVEMBER': 'Novembro',
		'DATE.OCTOBER': 'Outubro',
		'DATE.PERIOD': 'Intervalo',
		'DATE.RANGE': 'Intervalo de datas',
		'DATE.SATURDAY': 'Sábado',
		'DATE.SEPTEMBER': 'Setembro',
		'DATE.SUNDAY': 'Domingo',
		'DATE.THURSDAY': 'Quinta-feira',
		'DATE.TUESDAY': 'Terça-feira',
		'DATE.UNTIL': 'Até (Data)',
		'DATE.WEDNESDAY': 'Quarta-feira',
		'DAY.CURRENT': 'Dia atual',
		'DAY.NEXT': 'Dia seguinte',
		'DAY.PREVIOUS': 'Dia anterior',
		'DAY.SELECTED': 'Dia selecionado',
		'DAYS': 'Dias',
		'DAY_ACTIVITIES': 'Atividades diárias',
		'DEACTIVATE': 'Funcionários desativados',
		'DEACTIVATE.SELECTED': 'Desativar selecionados',
		'DEADLINE': 'Prazo',
		'DEADLINE.ADD': 'Adicionar prazo',
		'DEADLINE.ADD.SUCCESS': 'Prazo adicionado com sucesso',
		'DEADLINE.DELETE.SUCCESS': 'Prazo excluído com sucesso',
		'DEADLINE.DONE': 'Finalizar',
		'DEADLINE.DUE': 'Prazo',
		'DEADLINE.DUE_IN_AT': 'Prazo',
		'DEADLINE.EDIT': 'Editar prazo',
		'DEADLINE.EDIT.SUCCESS': 'Data limite editada',
		'DEADLINE.IS_CLOSE': 'Este prazo está próximo',
		'DEADLINE.IS_OVERDUE': 'Este prazo está vencido',
		'DEADLINE.OPEN': 'Aberto',
		'DEADLINE.PROCESS.SUCCESS': 'Prazo processado com sucesso',
		'DEADLINE.PROCESSED': 'Processado',
		'DEADLINE.PROCESSED.SUCCESS': 'Prazo processado com sucesso',
		'DEADLINE.WARN': 'O prazo está próximo',
		'DEADLINES': 'Prazos',
		'DEADLINES.NO': 'Nenhum prazo',
		'DEFINE_ROLE': 'Definir função',
		'DELETE': 'Excluir dados ISO',
		'DELETE.SELECTED': 'Excluir selecionado',
		'DELETED': 'Excluído',
		'DESCRIPTION': 'Descrição',
		'DIAGRAM': 'Gráfico',
		'DISPLAY': 'Exibição',
		'DISPLAY_TRACK': 'Pista de exibição',
		'DISTANCE': 'Distância',
		'DISTANCE.TOTAL': 'Distância total',
		'DISTANCE.WORKED': 'Distância percorrida',
		'DOWNLOAD': 'Download',
		'DRIVER': 'Motorista',
		'DRIVER.EDIT': 'Editar condutor',
		'DRIVER.FIXED': 'Motorista fixo',
		'DRIVER.NO': 'Nenhum motorista',
		'DRIVER.REMOVE': 'Retirar o condutor',
		'DRIVERS': 'Motoristas',
		'DRIVERS.ALL': 'Todos os motoristas',
		'DRIVER_SCAN_DISABLED': 'Radiogoniômetro inativo',
		'DURATION': 'Duração',
		'DURATION.WORKED': 'Duração do trabalho',
		'EDIT': 'Editar',
		'EDIT.SELECTED': 'Editar selecionado',
		'EDIT_USER': 'Editar usuário.',
		'EMAIL': 'E-mail',
		'EMAIL.ACTIVATE': 'Ativar e-mail',
		'EMAIL.ACTIVATE.CODE': 'Código de ativação',
		'EMAIL.ACTIVATE.EXPLANATION': 'Se você alterou o seu endereço de e-mail, você receberá um código de ativação no seu novo endereço de e-mail.',
		'EMAIL.CHANGE': 'Alterar e-mail',
		'EMAIL.CHANGE.SUCCESS': 'O seu endereço de e-mail foi alterado com sucesso',
		'EMAIL.CONFIRM': 'Confirmar e-mail',
		'EMAIL.CURRENT': 'Endereço de e-mail atual',
		'EMAIL.INVALID': 'E-mail',
		'EMAIL.NEW': 'Novo endereço de e-mail',
		'EMAIL.NO_MATCH': 'Os e-mails não coincidem',
		'EMPLOYEE': 'Funcionário',
		'EMPLOYEE.ACTIVATE.QUESTION': 'Deseja realmente ativar o funcionário?',
		'EMPLOYEE.ADD': 'Adicionar funcionário',
		'EMPLOYEE.ADD.SUCCESS': 'Funcionário adicionado com sucesso',
		'EMPLOYEE.CREATE': 'Criar funcionário',
		'EMPLOYEE.CREATE.SUCCESS': 'Funcionário criado com sucesso',
		'EMPLOYEE.DEACTIVATE.QUESTION': 'Deseja realmente marcar o funcionário como inativo?',
		'EMPLOYEE.DELETE.QUESTION': 'Deseja realmente remover o funcionário?',
		'EMPLOYEE.EDIT': 'Editar funcionários',
		'EMPLOYEE.EDIT.SUCCESS': 'Funcionário editado com sucesso',
		'EMPLOYEE.ROLE': 'Função do funcionário',
		'EMPLOYEE.ROLE_OF': 'Função do funcionário',
		'EMPLOYEES': 'Funcionários',
		'EMPLOYEES.ACTIVATE.QUESTION': 'Quer mesmo ativar os empregados?',
		'EMPLOYEES.ACTIVATE.SUCCESS': 'Funcionários ativados com sucesso',
		'EMPLOYEES.ALL': 'Todos os funcionários',
		'EMPLOYEES.DEACTIVATE.FAILURE': 'Alguns funcionários não puderam ser desativados.',
		'EMPLOYEES.DEACTIVATE.QUESTION': 'Você realmente deseja desativar os funcionários selecionados?',
		'EMPLOYEES.DEACTIVATE.SUCCESS': 'Funcionários foram desativados',
		'EMPLOYEES.DELETE.FAILURE': 'Alguns funcionários não puderam ser deletados.',
		'EMPLOYEES.DELETE.QUESTION': 'Você realmente deseja deletar os funcionários selecionados?',
		'EMPLOYEES.DELETE.SUCCESS': 'Funcionários deletados',
		'EMPLOYEES.MANAGEMENT': 'Gestão de funcionários',
		'EMPLOYEES.NO': 'Não há funcionários',
		'EMPLOYEES.NOT_SELECTED': 'Nenhum funcionário selecionado',
		'EMPLOYEES.SELECTED': 'Funcionários selecionados',
		'EMPLOYER.NO': 'Nenhum empregador',
		'EMPLOYER.NOT_SELECTED': 'Nenhum empregador selecionado',
		'EMPLOYES.NO': 'Nenhum funcionário',
		'END_DRAW_MODE': 'Modo de desenho cancelado',
		'ENTERPRISE': 'Empresa',
		'ENTERPRISE.ADD': 'Adicionar uma empresa',
		'ENTERPRISE.ADD.EMPLOYER_REQUIRED': 'Você precisa adicionar um empregador',
		'ENTERPRISE.ADDED.SUCCESS': 'Firma została pomyślnie dodana',
		'ENTERPRISE.ADD.SUCCESS': 'Empresa adicionada com sucesso.',
		'ENTERPRISE.ENTER_ACCESS_TOKEN': 'Por favor, insira o código de acesso para confirmar a adição da empresa.',
		'ENTERPRISE.NAME': 'Nome da empresa',
		'ENTERPRISE.NOT_SELECTED': 'Por favor, selecione uma empresa.',
		'ENTERPRISE.OF': 'Empresa de:',
		'ENTERPRISE.SETTINGS': 'Configurações',
		'ENTERPRISE.SETTINGS.CONFIGURATION_UPDATE.SUCCESS': 'Configurações da empresa atualizadas com sucesso',
		'ENTERPRISE.SETTINGS.MACHINES_SYNC.SUCCESS': 'Máquinas sincronizadas com sucesso',
		'ENTERPRISE_LICENSE.EMPLOYEES': 'Licença dos funcionários',
		'ENTERPRISE_LICENSE.LICENSE': 'Licença',
		'ENTERPRISE_LICENSE.MACHINE': 'Licença da máquina',
		'ENTERPRISE_LICENSE.MACHINES': 'Licenças das máquinas',
		'ENTERPRISE_MIN': 'O nome da empresa deve ter pelo menos 3 caracteres.',
		'ENTERPRISE_NAME_REQUIRED': 'É necessário informar o nome da empresa',
		'ENTERPRISE_SELECTION.ADD_ENTERPRISE': 'Adicionar empresa',
		'ENTERPRISE_SELECTION.LICENSE_EXPIRED': 'Licença espirada',
		'ENTERPRISE_SELECTION.REQUEST_TEST_ACCOUNT': 'Solicitar conta de teste',
		'ENTERPRISE_STATISTICS': 'Estatísticas da empresa',
		'ENTERPRISE_STATISTICS.COST_DIAGRAMM': 'Diagrama de custos',
		'ENTERPRISE_STATISTICS.PROCESS_DIVISION': 'Lista de processos',
		'ENUM.ACCOUNTING_COMP_MODE.A': 'Tudo',
		'ENUM.ACCOUNTING_COMP_MODE.WT': 'Trabalhando / Transportando',
		'ENUM.ACCOUNTING_MODE.AVG': 'Média',
		'ENUM.ACCOUNTING_MODE.MAX': 'Máximo',
		'ENUM.ACCOUNTING_MODE.MED': 'Mediana',
		'ENUM.ACCOUNTING_MODE.MIN': 'Mínimo',
		'ENUM.ACCOUNTING_MODE.SUM': 'Soma',
		'ENUM.ACCOUNTING_VALUE_MODE.ABSDIF': 'Diferença absoluta',
		'ENUM.ACCOUNTING_VALUE_MODE.DIR': 'Direto',
		'ENUM.ACCOUNTING_VALUE_MODE.NEGDIF': 'Diferença negativa',
		'ENUM.ACCOUNTING_VALUE_MODE.POSDIF': 'Diferença positiva',
		'ENUM.ACCOUNTING_VALUE_MODE.TIMACT': 'Tempo ativo',
		'ENUM.BEACONTYPE.BDrv': 'Farol do condutor',
		'ENUM.BEACONTYPE.BImpl': 'Alfaia beacon',
		'ENUM.CAN_IDENTIFIER.A1': 'Analógico 1',
		'ENUM.CAN_IDENTIFIER.A2': 'Analógico 2',
		'ENUM.CAN_IDENTIFIER.A3': 'Analógico 3',
		'ENUM.CAN_IDENTIFIER.A4': 'Analógico 4',
		'ENUM.CAN_IDENTIFIER.AUX0_Ext_Fl': 'AUX0 fluxo externo',
		'ENUM.CAN_IDENTIFIER.AUX0_Ret_Fl': 'AUX0 fluxo de retracção',
		'ENUM.CAN_IDENTIFIER.AUX1_Ext_Fl': 'AUX1 fluxo externo',
		'ENUM.CAN_IDENTIFIER.AUX1_Ret_Fl': 'AUX1 fluxo de retracção',
		'ENUM.CAN_IDENTIFIER.AUX2_Ext_Fl': 'AUX2 fluxo externo',
		'ENUM.CAN_IDENTIFIER.AUX2_Ret_Fl': 'AUX2 fluxo de retracção',
		'ENUM.CAN_IDENTIFIER.AUX3_Ext_Fl': 'AUX3 fluxo externo',
		'ENUM.CAN_IDENTIFIER.AUX3_Ret_Fl': 'AUX3 fluxo de retracção',
		'ENUM.CAN_IDENTIFIER.AUX4_Ext_Fl': 'AUX4 fluxo externo',
		'ENUM.CAN_IDENTIFIER.AUX4_Ret_Fl': 'AUX4 fluxo de retracção',
		'ENUM.CAN_IDENTIFIER.Ag1avg': 'Ângulo 1 média',
		'ENUM.CAN_IDENTIFIER.Ag1max': 'Ângulo 1 máx',
		'ENUM.CAN_IDENTIFIER.Ag1min': 'Ângulo 1 mín',
		'ENUM.CAN_IDENTIFIER.Ag2avg': 'Ângulo 2 média',
		'ENUM.CAN_IDENTIFIER.Ag2max': 'Ângulo 2 máx',
		'ENUM.CAN_IDENTIFIER.Ag2min': 'Ângulo 2 mín',
		'ENUM.CAN_IDENTIFIER.Ag3avg': 'Ângulo 3 média',
		'ENUM.CAN_IDENTIFIER.Ag3max': 'Ângulo 3 máx',
		'ENUM.CAN_IDENTIFIER.Ag3min': 'Ângulo 3 mín',
		'ENUM.CAN_IDENTIFIER.ApplAci': 'Acido aplicado',
		'ENUM.CAN_IDENTIFIER.ApplAdd': 'Aditivo aplicado',
		'ENUM.CAN_IDENTIFIER.ApplSlu': 'Adubo líquido aplicado',
		'ENUM.CAN_IDENTIFIER.AxleWeight_1': 'Peso do eixo 1',
		'ENUM.CAN_IDENTIFIER.AxleWeight_2': 'Peso do eixo 2',
		'ENUM.CAN_IDENTIFIER.C1': 'Contador 1',
		'ENUM.CAN_IDENTIFIER.C2': 'Contador 2',
		'ENUM.CAN_IDENTIFIER.Chop_Act': 'Picador',
		'ENUM.CAN_IDENTIFIER.Circ_1_Stat': 'Circ_1_Stat',
		'ENUM.CAN_IDENTIFIER.Circ_2A_Stat': 'Circ_2A_Stat',
		'ENUM.CAN_IDENTIFIER.Circ_2B_Stat': 'Circ_2B_Stat',
		'ENUM.CAN_IDENTIFIER.Circ_3_Stat': 'Circ_3_Stat',
		'ENUM.CAN_IDENTIFIER.Circ_4_Stat': 'Circ_4_Stat',
		'ENUM.CAN_IDENTIFIER.ClutSlip': 'Patinagem da embreagem',
		'ENUM.CAN_IDENTIFIER.Cutter_Guide': 'Guia do cortador',
		'ENUM.CAN_IDENTIFIER.Cutter_GuideP': 'Guia do cortador (P)',
		'ENUM.CAN_IDENTIFIER.Cutter_Pos': 'Posição do cortador',
		'ENUM.CAN_IDENTIFIER.Cutter_State': 'Cortador',
		'ENUM.CAN_IDENTIFIER.D1': 'Digital 1',
		'ENUM.CAN_IDENTIFIER.D2': 'Digital 2',
		'ENUM.CAN_IDENTIFIER.D3': 'Digital 3',
		'ENUM.CAN_IDENTIFIER.D4': 'Digital 4',
		'ENUM.CAN_IDENTIFIER.Driv_Lever': 'Alavanca de acionamento',
		'ENUM.CAN_IDENTIFIER.ENG_ABLev': 'Nível de AdBlue',
		'ENUM.CAN_IDENTIFIER.ENG_FueLev': 'Nível do tanque',
		'ENUM.CAN_IDENTIFIER.ENG_FueRat': 'Consumo de combustível',
		'ENUM.CAN_IDENTIFIER.ENG_Spe': 'Velocidade do motor',
		'ENUM.CAN_IDENTIFIER.ENG_Tor': 'Torque do motor',
		'ENUM.CAN_IDENTIFIER.FHitch_Pos': 'Posição do engate dianteiro',
		'ENUM.CAN_IDENTIFIER.FPTO_Eng': 'TF dianteira ativa',
		'ENUM.CAN_IDENTIFIER.FPTO_Spe': 'Velociade da TF do eixo dianteiro',
		'ENUM.CAN_IDENTIFIER.Field_Switch': 'Interruptor_de_campo',
		'ENUM.CAN_IDENTIFIER.Field_Switch2': 'Interruptor_de_campo2',
		'ENUM.CAN_IDENTIFIER.Front_Draft': 'Força de tração dianteira',
		'ENUM.CAN_IDENTIFIER.Front_NForce': 'Força de tração nominal dianteira',
		'ENUM.CAN_IDENTIFIER.GB_Dir': 'Direção (com base no solo)',
		'ENUM.CAN_IDENTIFIER.GB_Speed': 'Velocidade em solo',
		'ENUM.CAN_IDENTIFIER.GPS_Speed': 'Velocidade da GPS',
		'ENUM.CAN_IDENTIFIER.Gear_Sel': 'Marcha selecionada',
		'ENUM.CAN_IDENTIFIER.GrainCnv_Pos': 'Posição do transportador de grãos',
		'ENUM.CAN_IDENTIFIER.GrainTnk_Lev': 'Nível do tanque de grãos',
		'ENUM.CAN_IDENTIFIER.HySt_Dir': 'HySt_Dir',
		'ENUM.CAN_IDENTIFIER.HySt_Mod': 'HySt_Mod',
		'ENUM.CAN_IDENTIFIER.Impl_Work': 'Implementar workstate',
		'ENUM.CAN_IDENTIFIER.JbSta': 'Trabalho ativo',
		'ENUM.CAN_IDENTIFIER.Mot_L_Spe': 'Velocidade do motor (esquerda)',
		'ENUM.CAN_IDENTIFIER.Mot_L_Tor': 'Binário do motor (esquerdo)',
		'ENUM.CAN_IDENTIFIER.Mot_R_Spe': 'Velocidade do motor (direita)',
		'ENUM.CAN_IDENTIFIER.Mot_R_Tor': 'Binário do motor (direita)',
		'ENUM.CAN_IDENTIFIER.NO_XTR': 'Nenhum valor',
		'ENUM.CAN_IDENTIFIER.NUE_abs': 'SyreN: NUE absoluto',
		'ENUM.CAN_IDENTIFIER.NUE_rel': 'SyreN: Parente NUE',
		'ENUM.CAN_IDENTIFIER.PHSlu': 'pH do adubo líquido',
		'ENUM.CAN_IDENTIFIER.PTO_Switch': 'TDF_Switch',
		'ENUM.CAN_IDENTIFIER.PTO_Switch1': 'TDF_Switch1',
		'ENUM.CAN_IDENTIFIER.PTO_Switch2': 'TDF_Switch2',
		'ENUM.CAN_IDENTIFIER.PTO_Switch3': 'TDF_Switch3',
		'ENUM.CAN_IDENTIFIER.PrxSen': 'Sensor de proximidade',
		'ENUM.CAN_IDENTIFIER.RHitch_Pos': 'Posição do engate traseiro',
		'ENUM.CAN_IDENTIFIER.RPTO_Eng': 'TF traseira ativa',
		'ENUM.CAN_IDENTIFIER.RPTO_Spe': 'Velociade da TF do eixo traseiro',
		'ENUM.CAN_IDENTIFIER.Rear_Draft': 'Força de tração traseira',
		'ENUM.CAN_IDENTIFIER.Rear_NForce': 'Força de tração nominal traseira',
		'ENUM.CAN_IDENTIFIER.Roll': 'Velocidade de rotação',
		'ENUM.CAN_IDENTIFIER.Sli': 'Patinagem',
		'ENUM.CAN_IDENTIFIER.Spe': 'Velocidade',
		'ENUM.CAN_IDENTIFIER.StrawChop_Pos': 'Posição dos morcegos',
		'ENUM.CAN_IDENTIFIER.Thresh_Drum': 'Tambor de trilha',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A1': 'Pressão dos pneus esquerdos A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A2': 'Pressão dos pneus esquerdos A2',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A1': 'Pressão dos pneus dereitos A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A2': 'Pressão dos pneus dereitos A2',
		'ENUM.CAN_IDENTIFIER.UnlAuger_Act': 'UnlAuger_Act',
		'ENUM.CAN_IDENTIFIER.WB_Dir': 'Direção (com base na roda)',
		'ENUM.CAN_IDENTIFIER.WB_Speed': 'Velocidade da roda',
		'ENUM.CAN_IDENTIFIER.Xacc': 'Aceleração X',
		'ENUM.CAN_IDENTIFIER.Yacc': 'Aceleração Y',
		'ENUM.CAN_IDENTIFIER.Yaw': 'Taxa de guinada',
		'ENUM.CAN_IDENTIFIER.Yield_Act': 'Rendimento real',
		'ENUM.CAN_IDENTIFIER.Yield_Mois': 'Umidade de rendimento ',
		'ENUM.CAN_IDENTIFIER.Zacc': 'Aceleração Z',
		'ENUM.COSTPER.h': 'h',
		'ENUM.COSTPER.ha': 'ha',
		'ENUM.COSTPER.km': 'km',
		'ENUM.COSTPER.l': 'l',
		'ENUM.CURRENCY.DOLLAR': '$',
		'ENUM.CURRENCY.EURO': '€',
		'ENUM.CURRENCY.GBP': '£',
		'ENUM.EMPLOYEEROLE.ADMIN': 'Administrador',
		'ENUM.EMPLOYEEROLE.CONSULTANT': 'Consultor',
		'ENUM.EMPLOYEEROLE.DISPONENT': 'Despachante',
		'ENUM.EMPLOYEEROLE.DRIVER': 'Motorista',
		'ENUM.EVENTTYPE.COMMENT': 'Comentário',
		'ENUM.EVENTTYPE.CT': 'Contador',
		'ENUM.EVENTTYPE.CT_RS': 'Reinicialização do contador',
		'ENUM.EVENTTYPE.CUSTOMER': 'Cliente',
		'ENUM.EVENTTYPE.EMPL_C_IMPL': 'Funcionário acopla a alfaia',
		'ENUM.EVENTTYPE.EMPL_E_FIELD': 'Funcionário entra no campo',
		'ENUM.EVENTTYPE.EMPL_E_MACH': 'Funcionário entra no trator',
		'ENUM.EVENTTYPE.EMPL_L_FIELD': 'Funcionário sai do campo',
		'ENUM.EVENTTYPE.EMPL_L_MACH': 'Funcionário sai do trator',
		'ENUM.EVENTTYPE.EMPL_P_START': 'Funcionário faz uma pausa',
		'ENUM.EVENTTYPE.EMPL_P_STOP': 'Fim da pausa do funcionário',
		'ENUM.EVENTTYPE.EMPL_UC_IMPL': 'Funcionário desacopla alfaia',
		'ENUM.EVENTTYPE.EMPL_W_START': 'Funcionário inicia o trabalho',
		'ENUM.EVENTTYPE.EMPL_W_STOP': 'Funcionário encerra o trabalho',
		'ENUM.EVENTTYPE.GTO70': 'Volume do tanque de grãos',
		'ENUM.EVENTTYPE.JOBINFO': 'Informação do trabalho',
		'ENUM.EVENTTYPE.JOB_PAUSE': 'Pausa do trabalho',
		'ENUM.EVENTTYPE.JOB_RESUME': 'Continuação do trabalho',
		'ENUM.EVENTTYPE.JOB_START': 'Início do trabalho',
		'ENUM.EVENTTYPE.JOB_STOP': 'Fim do trabalho',
		'ENUM.EVENTTYPE.L_IMPL': 'Alfaia carregada',
		'ENUM.EVENTTYPE.REFUELING': 'Reabastecimento',
		'ENUM.EVENTTYPE.SYREN_CUSTOMER': 'Cliente SyreN',
		'ENUM.EVENTTYPE.SYREN_FIELD': 'Campo SyreN',
		'ENUM.EVENTTYPE.SYREN_SLURRY_TYPE': 'Tipo de lama SyreN',
		'ENUM.EVENTTYPE.T2_ON': 'Adapter em linha',
		'ENUM.EVENTTYPE.UL_IMPL': 'Alfaia descarregadoa',
		'ENUM.EVENTTYPE.WEATHER': 'Clima',
		'ENUM.EVENTTYPE.WEIGHING': 'Pesagem',
		'ENUM.EVENTTYPE.WEIGHING_TARA': 'Pesagem (tara)',
		'ENUM.ISO_TASKDATA_STATE.CRE': 'Criado',
		'ENUM.ISO_TASKDATA_STATE.ONM': 'Na máquina',
		'ENUM.ISO_TASKDATA_STATE.RDY': 'Pronto',
		'ENUM.JOBGENERATIONSTATE.ARC': 'Arquivado',
		'ENUM.JOBGENERATIONSTATE.DEL': 'Excluindo',
		'ENUM.JOBGENERATIONSTATE.EDT': 'Editando',
		'ENUM.JOBGENERATIONSTATE.GEN': 'Gerando',
		'ENUM.JOBGENERATIONSTATE.MER': 'Mesclando',
		'ENUM.JOBGENERATIONSTATE.QUE': 'Em fila',
		'ENUM.JOBGENERATIONSTATE.READY': 'OK',
		'ENUM.JOBGENERATIONSTATE.REGEN': 'Regenerando',
		'ENUM.JOBGENERATIONSTATE.SPLT': 'Separando',
		'ENUM.JOBGENERATIONSTATE.UPD': 'Actualização',
		'ENUM.LOCATIONTYPE.FARM': 'Fazenda',
		'ENUM.LOCATIONTYPE.FUEL': 'Local de abastecimento',
		'ENUM.LOCATIONTYPE.OTHERS': 'Outros',
		'ENUM.LOCATIONTYPE.STABLE': 'Estável',
		'ENUM.LOCATIONTYPE.WEIGHING': 'Pesagem',
		'ENUM.MACHINETYPE.COMBINE': 'Colheitadeira',
		'ENUM.MACHINETYPE.EXCAVATOR': 'Escavadora',
		'ENUM.MACHINETYPE.FORAGE_HARVESTER': 'Ensiladeira',
		'ENUM.MACHINETYPE.MISC': 'Outros',
		'ENUM.MACHINETYPE.SELF_PROPELLED': 'Autônomo',
		'ENUM.MACHINETYPE.SYREN': 'Syren',
		'ENUM.MACHINETYPE.TELEHANDLER': 'Manipulador telescópico',
		'ENUM.MACHINETYPE.TRACTOR': 'Trator',
		'ENUM.MACHINETYPE.TRUCK': 'Caminhão',
		'ENUM.MACHINETYPE.WHEELLOADER': 'Carregador de rodas',
		'ENUM.MSGUNIT.-': '-',
		'ENUM.MSGUNIT.AXLES': 'Ejes',
		'ENUM.MSGUNIT.CUBIC_M': 'm³',
		'ENUM.MSGUNIT.DOLLAR': '$',
		'ENUM.MSGUNIT.EURO': '€',
		'ENUM.MSGUNIT.KG': 'kg',
		'ENUM.MSGUNIT.LITER': 'l',
		'ENUM.MSGUNIT.TONS': 't',
		'ENUM.MSGUNIT.h': 'h',
		'ENUM.MSGUNIT.ha': 'ha',
		'ENUM.MSGUNIT.km': 'km',
		'ENUM.ONLY_ON_STATE.A': 'Sempre',
		'ENUM.ONLY_ON_STATE.F': 'Campo',
		'ENUM.ONLY_ON_STATE.L': 'Local',
		'ENUM.ONLY_ON_STATE.R': 'Estrada',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_1200': 'AgLeader InCommand 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_800': 'AgLeader InCommand 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INTEGRA': 'AgLeader Integra',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_VERSA': 'AgLeader Versa',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD': 'Amazone Amapad',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD_2': 'Amazone Amapad 2',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_3': 'Amazone Amatron 3',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_4': 'Amazone Amatron 4',
		'ENUM.TRACTOR_TERMINAL_TYPE.AN_L10I': 'Andeo L10i',
		'ENUM.TRACTOR_TERMINAL_TYPE.A_XY': 'A_XY',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_1200': 'Case AFS Pro 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_700': 'Case AFS Pro 700',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_1200': 'CCI 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_800': 'CCI 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_CEMIS_1200': 'Claas Cemis 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S10': 'Claas S10',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S7': 'Claas S7',
		'ENUM.TRACTOR_TERMINAL_TYPE.C_S2034': 'C_S2034',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_ONE': 'Fendt One',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_VARIOTERMINAL_10_4': 'Fendt Varioterminal 10.4',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_2630': 'John Deere 2630',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_GEN4': 'John Deere Gen4',
		'ENUM.TRACTOR_TERMINAL_TYPE.KV_TELLUS': 'Kverneland Tellus',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME': 'Müller Elektronik Basic',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_COMFORT': 'Müller Elektronik Comfort',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_1200': 'Müller Elektronik Touch 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_800': 'Müller Elektronik Touch 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.MF_DATATRONIC_5': 'MF Datatronic 5',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR12': 'Raven CR12',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR7': 'Raven CR7',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_VIPER4': 'Raven Viper4',
		'ENUM.TRACTOR_TERMINAL_TYPE.RH_SMART_COMMAND': 'Reichhardt Smart Command',
		'ENUM.TRACTOR_TERMINAL_TYPE.SDF_IMONITOR3': 'SDF iMonitor3',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X25': 'Topcon x25',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X30': 'Topcon x30',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X35': 'Topcon x35',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_XD': 'Topcon XD',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_1260': 'Trimble GFX 1260',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_750': 'Trimble GFX 750',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_TMX_2050': 'Trimble TMX 2050',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_1': 'Tipo 1 (escreve na pen USB)',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_2': 'Tipo 2 (não escreve na pen USB)',
		'ENUM.TRANSPORTUNIT.-': '-',
		'ENUM.TRANSPORTUNIT.AXLES': 'Eixo',
		'ENUM.TRANSPORTUNIT.BALE': 'Fardo',
		'ENUM.TRANSPORTUNIT.CUBIC_M': 'm³',
		'ENUM.TRANSPORTUNIT.KG': 'kg',
		'ENUM.TRANSPORTUNIT.LITER': 'l',
		'ENUM.TRANSPORTUNIT.TONS': 't',
		'ENUM.USERROLE.ADMIN': 'Administrador',
		'ENUM.USERROLE.ENTERPRISE': 'Empresa',
		'ENUM.USERROLE.SALES_FORCE_TECH': 'Equipe de Vendas Técnicas',
		'ENUM.USERROLE.TRAN': 'Tradução',
		'ENUM.USERROLE.USER': 'Usuário',
		'ENUM.USERROLE.USER_EMPL': 'Utilizador (Empresa)',
		'ENUM.USERSTATE.ACTIVE': 'Ativo',
		'ENUM.USERSTATE.DISABLED': 'Desativado',
		'ENUM.USERSTATE.NOT_VERIFIED': 'Não verificado',
		'ENUM.WORKSTATE.DRIVING': 'Dirigindo',
		'ENUM.WORKSTATE.DRIVING_MISC': 'Tempo de espera da condução',
		'ENUM.WORKSTATE.MISC_FIELD': 'Tempo de espera do campo',
		'ENUM.WORKSTATE.MISC_FIELD_GTF': 'Volume do tanque de grãos',
		'ENUM.WORKSTATE.MISC_ROAD': 'Tempo de espera da estrada',
		'ENUM.WORKSTATE.PAUSE': 'Pausado',
		'ENUM.WORKSTATE.PREPARATION': 'Preparação',
		'ENUM.WORKSTATE.ROAD': 'Rua',
		'ENUM.WORKSTATE.THRESHING': 'Debulhando',
		'ENUM.WORKSTATE.THRESHING_U': 'Descarregando durante a debulha',
		'ENUM.WORKSTATE.THRESHING_W_SC': 'Debulhando com picador de palha',
		'ENUM.WORKSTATE.THRESHING_W_SC_U': 'Descarregamento durante a debulha com palhinha',
		'ENUM.WORKSTATE.TRANSPORT_LOADED': 'Carregado',
		'ENUM.WORKSTATE.TRANSPORT_LOADED_MISC': 'Tempo de espera do carregamento',
		'ENUM.WORKSTATE.TRANSPORT_LOADING': 'Carregando',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED': 'Descarregado',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED_MISC': 'Tempo de espera da descarga',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING': 'Descarregando',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING_DRIV': 'Descarregando durante a debulha',
		'ENUM.WORKSTATE.TURNING': 'Manobrando',
		'ENUM.WORKSTATE.UNDEFINED': 'Indefinido',
		'ENUM.WORKSTATE.WORKING': 'Trabalhando',
		'ENUM.WORKSTATE.WORKING_MISC': 'Tempo de espera do trabalho',
		'ERROR.NO_GPS_DATA': 'Não hA dados de GPS para a mAquina selecionada.',
		'ERROR_MESSAGE': 'Mensagem de erro',
		'EVENTS': 'Eventos',
		'EVENTS.FIELD': 'Eventos no campo',
		'EVENTS.NO': 'Nenhum evento',
		'EXA_ADAPTERS': 'Adaptador',
		'EXA_ADAPTERS.AR_ACTIVATE': 'Ativar adaptador no Agrirouter',
		'EXA_ADAPTERS.AR_DEACTIVATE': 'Excluir adaptador no Agrirouter',
		'EXA_ADAPTERS.AR_LINK_SUCCESS': 'Adaptador ativo no Agrirouter',
		'EXA_ADAPTERS.AR_UNLINK_SUCCESS': 'Adaptador excluído no Agrirouter',
		'EXCEPTION.1': 'Erro interno',
		'EXCEPTION.100': 'Enum inválido',
		'EXCEPTION.1000': 'Nome de usuário está vazio',
		'EXCEPTION.10000': 'Nome do arquivo está vazio',
		'EXCEPTION.10001': 'Dados estão vazios',
		'EXCEPTION.10002': 'Formato inválido',
		'EXCEPTION.10003': 'Requisição inválida',
		'EXCEPTION.10004': 'Sem dados brutos',
		'EXCEPTION.1001': 'Nome de usuário muito curto',
		'EXCEPTION.1002': 'Nome de usuário já utilizado',
		'EXCEPTION.1003': 'Endereço de e-mail inválido',
		'EXCEPTION.1004': 'Endereço de e-mail já utilizado',
		'EXCEPTION.1005': 'Senha muito curta',
		'EXCEPTION.1007': 'Código de verificação inválido',
		'EXCEPTION.1008': 'Nome de usuário (ou e-mail) inválido',
		'EXCEPTION.101': 'Função do funcionário inválida',
		'EXCEPTION.1011': 'Usuário não existe',
		'EXCEPTION.1012': 'Usuário foi deletado',
		'EXCEPTION.1013': 'Usuário está inativo',
		'EXCEPTION.1014': 'Usuário está bloqueado',
		'EXCEPTION.1015': 'Usuário não está ativo',
		'EXCEPTION.1016': 'Usuário é uma conta empresarial',
		'EXCEPTION.102': 'Moeda inválida',
		'EXCEPTION.1020': 'Usuário já existente',
		'EXCEPTION.1021': 'Endereço de e-mail já tomado',
		'EXCEPTION.1022': 'Endereço de e-mail já tomado',
		'EXCEPTION.1023': 'Senha actual não corresponde',
		'EXCEPTION.1024': 'O nome de utilizador já está ocupado',
		'EXCEPTION.1025': 'O utilizador e o código não coincidem',
		'EXCEPTION.1026': 'Nome de utilizador (ou endereço de e-mail) inválido',
		'EXCEPTION.1027': 'Utilizador já activado',
		'EXCEPTION.1028': 'Proibido para contas de empregados criadas para uma empresa',
		'EXCEPTION.103': 'Unidade de transporte inválida',
		'EXCEPTION.104': 'Tipo de local inválido',
		'EXCEPTION.105': 'Unidade de custo inválida',
		'EXCEPTION.106': 'Unidade inválida',
		'EXCEPTION.107': 'Tipo de máquina inválido',
		'EXCEPTION.108': 'Estatuto de empregado inválido',
		'EXCEPTION.11000': 'Tipo inválido',
		'EXCEPTION.12000': 'Tipo inválido',
		'EXCEPTION.12002': 'A série está vazia',
		'EXCEPTION.12003': 'Estado de trabalho inválido',
		'EXCEPTION.12004': 'Estado do emprego inválido',
		'EXCEPTION.12006': 'Sem configuração T2',
		'EXCEPTION.12007': 'MAC está vazio',
		'EXCEPTION.12008': 'MAC inválido',
		'EXCEPTION.12009': 'O adaptador já existe',
		'EXCEPTION.12010': 'Tipo de adaptador inválido',
		'EXCEPTION.15000': 'O tempo de paragem está vazio ou no futuro',
		'EXCEPTION.15001': 'O tempo de paragem está vazio ou no futuro',
		'EXCEPTION.15002': 'O tempo de paragem é igual ou antes da hora de início',
		'EXCEPTION.15003': 'Não é capaz de gerar o pacote SILO - sem dados em bruto',
		'EXCEPTION.15004': 'Dados brutos demasiado antigos',
		'EXCEPTION.16000': 'O nome está vazio',
		'EXCEPTION.16001': 'O cliente designado não existe',
		'EXCEPTION.16002': 'A lista de marcadores está vazia',
		'EXCEPTION.16003': 'A lista de marcadores tem de conter pelo menos três marcadores',
		'EXCEPTION.16004': 'A área está vazia',
		'EXCEPTION.16005': 'Tipo de marcador inválido',
		'EXCEPTION.16006': 'O campo não está contido no trabalho',
		'EXCEPTION.16007': 'O tamanho da grelha é superior a metade da altura e largura do campo',
		'EXCEPTION.16008': 'Sem dados a interpolar',
		'EXCEPTION.16009': 'Todos os dados contêm o mesmo valor',
		'EXCEPTION.17000': 'O nome está vazio',
		'EXCEPTION.17001': 'A pessoa de contacto está vazia',
		'EXCEPTION.17002': 'O telefone está vazio',
		'EXCEPTION.17003': 'O endereço de e-mail está vazio',
		'EXCEPTION.17004': 'Endereço de e-mail inválido',
		'EXCEPTION.17005': 'O endereço está vazio',
		'EXCEPTION.17006': 'O código postal está vazio',
		'EXCEPTION.17007': 'A cidade está vazia',
		'EXCEPTION.17008': 'Cor inválida ((AA)RRGGBB)',
		'EXCEPTION.18000': 'Tipo inválido',
		'EXCEPTION.19001': 'Tipo inválido',
		'EXCEPTION.19002': 'MAC está vazio',
		'EXCEPTION.19003': 'MAC inválido',
		'EXCEPTION.19004': 'A potência é inferior a zero',
		'EXCEPTION.19007': 'Empregado está vazio',
		'EXCEPTION.19008': 'O farol não é um farol de alfaias',
		'EXCEPTION.19009': 'O farol não é um farol de condutor',
		'EXCEPTION.2': 'Duplicação da entrada',
		'EXCEPTION.200': 'Análise de erros do tipo de objecto Json',
		'EXCEPTION.2000': 'Criação de código de verificação falhou',
		'EXCEPTION.20000': 'Quantidade de dados brutos demasiado baixa',
		'EXCEPTION.20001': 'Criação de ficheiros de arquivo falhou',
		'EXCEPTION.20002': 'Carregamento de ficheiros de arquivo falhou',
		'EXCEPTION.2001': 'O código de verificação não existe',
		'EXCEPTION.2002': 'Código de verificação inválido',
		'EXCEPTION.201': 'Tipo de objecto de escrita de erro para Json',
		'EXCEPTION.21000': 'O nome da empresa está vazio',
		'EXCEPTION.21001': 'Nome da empresa já tomado',
		'EXCEPTION.21002': 'O comprimento do nome da empresa é inferior ao comprimento mínimo',
		'EXCEPTION.21003': 'Endereço de e-mail da empresa inválido',
		'EXCEPTION.21004': 'O código de acesso já existe',
		'EXCEPTION.21005': 'A empresa é eliminada',
		'EXCEPTION.21006': 'A empresa está desactivada',
		'EXCEPTION.21007': 'A empresa está bloqueada',
		'EXCEPTION.21008': 'Tipo de empresa inválido',
		'EXCEPTION.22000': 'Nenhum trabalho a acrescentar',
		'EXCEPTION.22001': 'Nenhum trabalho mudou',
		'EXCEPTION.23000': 'Empresa não embarcada',
		'EXCEPTION.23001': 'Empresa já embarcada',
		'EXCEPTION.23002': 'Adaptador no integrado',
		'EXCEPTION.23003': 'Adaptador já a bordo',
		'EXCEPTION.23004': 'Não foi possível o adaptador a bordo',
		'EXCEPTION.23005': 'Não foi possível reactivar o adaptador de bordo',
		'EXCEPTION.23006': 'Não podia ser adaptador fora de bordo',
		'EXCEPTION.23007': 'As capacidades de publicação de vCU falharam',
		'EXCEPTION.23008': 'A publicação de dados vCU falhou',
		'EXCEPTION.23009': 'Falha na descrição do dispositivo de publicação de vCU',
		'EXCEPTION.23010': 'As capacidades da empresa editora falharam',
		'EXCEPTION.23011': 'Erro no certificado Agrirouter! Renovou a ligação Agrirouter?',
		'EXCEPTION.24000': 'O nome da empresa está vazio',
		'EXCEPTION.24001': 'Nome da empresa já tomado',
		'EXCEPTION.24002': 'O comprimento do nome da empresa é inferior ao comprimento mínimo',
		'EXCEPTION.24003': 'Endereço de e-mail da empresa inválido',
		'EXCEPTION.24004': 'O código de acesso já existe',
		'EXCEPTION.24005': 'A empresa é eliminada',
		'EXCEPTION.24006': 'A empresa está desactivada',
		'EXCEPTION.24007': 'A empresa está bloqueada',
		'EXCEPTION.25000': 'Função não disponível para parceiro seleccionado',
		'EXCEPTION.25001': 'Os campos de sincronização falharam',
		'EXCEPTION.25002': 'As máquinas sincronizadoras falharam',
		'EXCEPTION.25003': 'A sincronização de alfaias falhou',
		'EXCEPTION.25004': 'A máquina falhou',
		'EXCEPTION.25005': 'A criação da máquina falhou',
		'EXCEPTION.25006': 'A máquina de actualização falhou',
		'EXCEPTION.25007': 'A máquina de apagar falhou',
		'EXCEPTION.25008': 'Obtenção de alfaias falhou',
		'EXCEPTION.25009': 'A criação da alfaia falhou',
		'EXCEPTION.25010': 'Actualização da alfaia falhou',
		'EXCEPTION.25011': 'A eliminação da alfaia falhou',
		'EXCEPTION.26000': 'Criação de ficheiro PDF falhou',
		'EXCEPTION.26001': 'O trabalho seleccionado não é um trabalho habilitado pela SyreN',
		'EXCEPTION.27000': 'Máquina não suporta ficheiros TaskData',
		'EXCEPTION.27001': 'Criação de ficheiros TaskData falhou',
		'EXCEPTION.27002': 'Carregamento de ficheiros TaskData falhou',
		'EXCEPTION.27003': 'A máquina não tem adaptador atribuído',
		'EXCEPTION.27004': 'O nome está vazio',
		'EXCEPTION.27005': 'A data prevista está vazia',
		'EXCEPTION.27006': 'A data planeada não está no futuro',
		'EXCEPTION.27007': 'O Estado está vazio',
		'EXCEPTION.27008': 'O ficheiro está vazio',
		'EXCEPTION.27009': 'O nome do ficheiro está vazio',
		'EXCEPTION.27010': 'A data está vazia',
		'EXCEPTION.27011': 'A data não está no futuro',
		'EXCEPTION.27012': 'O tamanho é inferior a um',
		'EXCEPTION.27013': 'Operação TaskData não disponível no estado actual',
		'EXCEPTION.27014': 'Nome do ficheiro já tirado',
		'EXCEPTION.27015': 'Sem tarefas em aberto',
		'EXCEPTION.27016': 'Apenas um ficheiro de dados de tarefa não descarregado é permitido',
		'EXCEPTION.28001': 'Tipo de ficheiro não suportado',
		'EXCEPTION.29000': 'Actualização não permitida (já processada)',
		'EXCEPTION.29001': 'Nenhuma máquina ou alfaia dado',
		'EXCEPTION.29002': 'Apenas máquina ou alfaia permitido',
		'EXCEPTION.29003': 'O valor base tem de ser superior a zero',
		'EXCEPTION.29004': 'O valor do aviso tem de ser superior a zero',
		'EXCEPTION.29005': 'O valor devido tem de ser superior a zero',
		'EXCEPTION.29006': 'O intervalo devido tem de ser maior do que o intervalo de aviso',
		'EXCEPTION.3000': 'Informação de login inválida',
		'EXCEPTION.3001': 'A conta está bloqueada',
		'EXCEPTION.3002': 'A conta não é activada',
		'EXCEPTION.3003': 'Sessão expirou - Por favor, inicie novamente a sessão',
		'EXCEPTION.3004': 'Outro utilizador entrou com a mesma conta',
		'EXCEPTION.31000': 'App não suportado',
		'EXCEPTION.4000': 'A marca está vazia',
		'EXCEPTION.4001': 'O modelo está vazio',
		'EXCEPTION.4002': 'O ano tem de ser criado do que 1950 e não no futuro',
		'EXCEPTION.4003': 'O custo é inferior ou igual a zero',
		'EXCEPTION.4004': 'As horas de funcionamento são inferiores a zero',
		'EXCEPTION.4005': 'A quilometragem é inferior a zero',
		'EXCEPTION.4007': 'A largura de trabalho é inferior a zero',
		'EXCEPTION.4008': 'Cor inválida ((AA)RRGGBB)',
		'EXCEPTION.4009': 'XtrCanValuesConfig inválido',
		'EXCEPTION.401': 'Não autorizado',
		'EXCEPTION.4010': 'Demasiados valores de configuração',
		'EXCEPTION.4011': 'Configuração dinâmica inválida',
		'EXCEPTION.4012': 'O tipo de máquina não é tractor',
		'EXCEPTION.4013': 'Número máximo de licenças são tiradas',
		'EXCEPTION.4014': 'A data está no futuro',
		'EXCEPTION.4015': 'Anulação da velocidade inválida',
		'EXCEPTION.403': 'Proibido',
		'EXCEPTION.450': 'Erro de comando',
		'EXCEPTION.451': 'Sem licença necessária',
		'EXCEPTION.452': 'Parâmetro de filtro inválido',
		'EXCEPTION.5000': 'A marca está vazia',
		'EXCEPTION.5001': 'O modelo está vazio',
		'EXCEPTION.5002': 'O ano tem de ser criado do que 1950 e não no futuro',
		'EXCEPTION.5003': 'Tipo1 está vazio',
		'EXCEPTION.5004': 'Tipo2 inválido',
		'EXCEPTION.5005': 'O custo é inferior ou igual a zero',
		'EXCEPTION.5006': 'A largura de trabalho é inferior a zero',
		'EXCEPTION.5007': 'O valor do transporte é inferior a zero',
		'EXCEPTION.5008': 'Unidade de transporte inválida',
		'EXCEPTION.5009': 'Tipo3 inválido',
		'EXCEPTION.5010': 'Tipo combinação inválida',
		'EXCEPTION.5011': 'Identificador contabilístico inválido',
		'EXCEPTION.6000': 'Tipo inválido',
		'EXCEPTION.6001': 'O raio está vazio ou abaixo de zero',
		'EXCEPTION.6002': 'O nome está vazio',
		'EXCEPTION.6003': 'A lista de marcadores está vazia',
		'EXCEPTION.6004': 'A lista de marcadores tem de conter pelo menos três marcadores',
		'EXCEPTION.6005': 'Tipo de marcador inválido',
		'EXCEPTION.6006': 'Tipo de pesagem inválido',
		'EXCEPTION.700': 'Nome inválido',
		'EXCEPTION.7001': 'A conta não existe',
		'EXCEPTION.7002': 'A conta está bloqueada',
		'EXCEPTION.701': 'Fórmula inválida',
		'EXCEPTION.702': 'CANIdName inválido',
		'EXCEPTION.703': 'Condição inválida',
		'EXCEPTION.704': 'Nome inválido',
		'EXCEPTION.705': 'Parâmetro de estado de trabalho inválido',
		'EXCEPTION.706': 'Estado de trabalho inválido para tipo de alfaia',
		'EXCEPTION.707': 'Criação de ficheiros falhou',
		'EXCEPTION.800': 'Nome de configuração do valor inválido',
		'EXCEPTION.8000': 'Empregador está vazio',
		'EXCEPTION.8001': 'Empregado está vazio',
		'EXCEPTION.8002': 'Empregado não encontrado para empregador',
		'EXCEPTION.8003': 'Custo inferior a zero',
		'EXCEPTION.8004': 'Número máximo de licenças de utilizador obtidas',
		'EXCEPTION.8005': 'Não o seu empregador',
		'EXCEPTION.8006': 'O empregado já existe',
		'EXCEPTION.8007': 'O código de acesso está vazio',
		'EXCEPTION.8008': 'Código de acesso inválido',
		'EXCEPTION.8009': 'Pelo menos um administrador tem de existir numa empresa',
		'EXCEPTION.8010': 'O utilizador só pode ser ligado à empresa que criou o utilizador',
		'EXCEPTION.900': 'Não existe',
		'EXCEPTION.9000': 'A hora de início está vazia ou no futuro',
		'EXCEPTION.9001': 'O tempo de paragem está vazio ou no futuro',
		'EXCEPTION.9002': 'O tempo de paragem é igual ou inferior ao tempo de arranque',
		'EXCEPTION.9003': 'O condutor não é empregado do dono do emprego',
		'EXCEPTION.9004': 'A alfaia não pertence ao dono do emprego',
		'EXCEPTION.9005': 'Tipo1 inválido',
		'EXCEPTION.9006': 'Tipo2 inválido',
		'EXCEPTION.9007': 'Tipo3 inválido',
		'EXCEPTION.9008': 'Não é capaz de gerar o trabalho - sem dados em bruto',
		'EXCEPTION.9009': 'O proprietário da máquina não corresponde ao proprietário da alfaia',
		'EXCEPTION.901': 'Já existe',
		'EXCEPTION.9010': 'O trabalho já existe',
		'EXCEPTION.9012': 'O trabalho não está pronto',
		'EXCEPTION.9013': 'O trabalho está marcado para eliminação',
		'EXCEPTION.9014': 'Emprego é arquivado - Não há JobLocations disponíveis',
		'EXCEPTION.9015': 'Dados brutos demasiado antigos',
		'EXCEPTION.9016': 'Pelo menos um trabalho é parte de uma tarefa',
		'EXCEPTION.9017': 'Os trabalhos não correspondem (máquina, condutor, alfaia têm de corresponder)',
		'EXCEPTION.9018': 'A diferença entre empregos é demasiado grande',
		'EXCEPTION.9019': 'Pelo menos um trabalho é parte de uma tarefa',
		'EXCEPTION.902': 'O proprietário não existe',
		'EXCEPTION.9020': 'Sem tempos de divisão',
		'EXCEPTION.9021': 'O tempo de divisão não é maior do que o tempo de arranque e menor do que o tempo de paragem',
		'EXCEPTION.9022': 'Sem identificação de emprego para fusão',
		'EXCEPTION.9023': 'Pelo menos dois trabalhos necessários',
		'EXCEPTION.9024': 'A densidade de pontos tem de ser maior zero e menor ou igual a um',
		'EXCEPTION.903': 'O objecto com o id não existe',
		'EXCEPTION.904': 'Latitude fora de alcance',
		'EXCEPTION.905': 'Longitude fora de alcance',
		'EXCEPTION.906': 'O proprietário não coincide',
		'EXCEPTION.907': 'O parâmetro está vazio',
		'EXCEPTION.99': 'Parâmetro inválido',
		'EXPORT': 'Exportar o trabalho seleccionado',
		'EXPORT.FILTERED_JOBS': 'Exportar todos os trabalhos filtrados',
		'EXPORT.JOB_DETAILS': 'Detalhes do trabalho de exportação',
		'EXPORT.OPERATIONS.CUSTOMER.PERIOD': 'Exportar todos os dados do cliente no período selecionado',
		'EXPORT.OPERATIONS.FIELDS.PERIOD': 'Exportar todas as operações em campos no período seleccionado',
		'EXPORT.OPERATIONS.LOCATIONS.PERIOD': 'Exportar todas as operações em locais no período seleccionado',
		'EXPORT.POINTS': 'Pontos de data',
		'EXPORT.POLYGONS': 'Polígonos',
		'EXPORT.RAW_DATA_AS_SILO': 'Exportar dados brutos do trabalho como ficheiro SILO',
		'EXPORT.SELECTED': 'Exportação seleccionada',
		'EXPORT.SELECT_DATA': 'O relatório PDF deve conter os seguintes dados',
		'EXPORT.SELECT_PERIOD': 'Seleccione o período a exportar',
		'FIELD': 'Campos',
		'FIELD.ADD': 'Adicionar um campo',
		'FIELD.ADD.SUCCESS': 'Campo criado com sucesso.',
		'FIELD.DEACTIVATE.QUESTION': 'Você realmente deseja desativar o campo?',
		'FIELD.DEACTIVATE.SUCCESS': 'Campo desativado com sucesso',
		'FIELD.DELETE.QUESTION': 'Deseja realmente excluir:',
		'FIELD.DELETE.SUCCESS': 'Campo excluído',
		'FIELD.DETAILS': 'Detalhes do campo',
		'FIELD.DRAW.START': 'Desenhar campo no mapa agora!',
		'FIELD.EDIT.SUCCESS': 'Campo editado com sucesso',
		'FIELD.INTERPOLATE': 'Interpolar',
		'FIELD.INTERPOLATED_VALUES': 'Valores interpolados',
		'FIELD.INTERPOLATION': 'Interpolação',
		'FIELD.INTERPOLATION_SETTINGS': 'Configuração de interpolação',
		'FIELD.INTERPOLATION_SETTINGS.FINE': 'Fino',
		'FIELD.INTERPOLATION_SETTINGS.FINE+': 'Muito fino',
		'FIELD.INTERPOLATION_SETTINGS.ROUGH': 'Bruto',
		'FIELD.INTERPOLATION_SETTINGS.STANDARD': 'Padrão',
		'FIELD.NUMBER': 'Número do campo',
		'FIELD.PROCESSED': 'Campos cultivados',
		'FIELDS': 'Campos',
		'FIELDS.ALL': 'Todos os campos',
		'FIELDS.DEACTIVATE.FAILURE': 'Alguns dos campos não puderam ser desactivados.',
		'FIELDS.DEACTIVATE.QUESTION': 'Você realmente deseja desativar os campos?',
		'FIELDS.DEACTIVATE.SUCCESS': 'Campos desativados com sucesso',
		'FIELDS.DELETE.FAILURE': 'Alguns dos campos não puderam ser apagados.',
		'FIELDS.DELETE.QUESTION': 'Quer mesmo apagar os campos seleccionados?',
		'FIELDS.DELETE.SUCCESS': 'Os campos foram eliminados com sucesso',
		'FIELDS.EDIT': 'Campos de edição',
		'FIELDS.IMPORT': 'Importar campos',
		'FIELDS.IMPORT.ASSIGN_CUSTOMER.QUESTION': 'Deseja designar um cliente para os campos seleccionados?',
		'FIELDS.IMPORT.SHAPE': 'Por favor, seleccione um ficheiro SHAPE.',
		'FIELDS.IMPORT.SUCCESS': 'Campos importados com sucesso',
		'FIELDS.MANAGEMENT': 'Gerenciamento do campo',
		'FIELDS.NO': 'Nenhum campo foi tratado com esse processo',
		'FIELDS.NOT_SELECTED': 'Nenhum campo seleccionado',
		'FIELDS.REACTIVATE.FAILURE': 'Alguns dos campos não puderam ser reactivados.',
		'FIELDS.REACTIVATE.QUESTION': 'Pretende mesmo reativar os campos seleccionados?',
		'FIELDS.REACTIVATE.SUCCESS': 'Campos reactivados com êxito',
		'FIELDS.SELECT': 'Seleccionar campos',
		'FIELDS.SELECTED': 'Campo selecionado',
		'FILE': 'Ficheiro',
		'FILE.GENERATING': 'O ficheiro está a ser gerado e adicionado em breve ao gestor de ficheiros',
		'FILE.GENERATING.READY': 'Um novo arquivo está pronto para ser descarregado',
		'FILE.MANAGER': 'Gestor de arquivos',
		'FILE.NO_FILES': 'Nenhum arquivo existente',
		'FILE.UPLOAD': 'Carregar ficheiro',
		'FILE_TRANSFER': 'Gestão de dados ISO',
		'FILE_TRANSFER.ADD': 'Adicionar dados ISO',
		'FILE_TRANSFER.ADD.SUCCESS': 'Dados ISO adicionado com sucesso',
		'FILE_TRANSFER.CREATE': 'Adicionar dados ISO',
		'FILE_TRANSFER.DELETE.QUESTION': 'Deseja realmente remover os dados ISO?',
		'FILE_TRANSFER.DELETE.SUCCESS': 'Dados ISO removidos com sucesso',
		'FILE_TRANSFER.FINISHED_TASKS': 'Atividades finalizadas',
		'FILE_TRANSFER.NO': 'Sem dados ISO',
		'FILE_TRANSFER.QUEUED_TASKS': 'Atividades em aberto',
		'FILTER': 'Filtrar',
		'FIRMWARE_VERSION': 'Versão de Firmware',
		'FIRSTNAME': 'Nome',
		'FORMS.FILE_TOO_LARGE': 'O ficheiro é demasiado grande.',
		'FORMS.NO_PASSWORD_MATCH': 'As palavras-passe não coincidem!',
		'FORMS.REQUIRED': 'O nome do campo não pode estar vazio!',
    'FORMS.INVALID_EMAIL': 'O email introduzido é inválido!',
		'FORMULA': 'É necessArio informar a fórmula.',
		'FUEL': 'Combustível',
		'FUEL.CONSUMPTION': 'Consumo de combustível',
		'FUEL.CONSUMPTION.AREA': 'Consumo de combustível por área',
		'FUEL.CONSUMPTION.AVERAGE': 'Diesel por hora',
		'FUEL.CONSUMPTION.OVERALL': 'Consumo geral de combustível',
		'FUEL.CONSUMPTION.TOTAL': 'Consumo de diesel',
		'FUEL.COST': 'Custo do combustível',
		'FUEL.LEVEL': 'Nível do tanque',
		'FUEL.PRICE_PER_LITER': 'Preço do combustível por litro',
		'FUEL.WARNING': 'Nível de combustível baixo!',
		'GENERAL_INSPECTION': 'Inspecção geral',
		'GEOMETRIES.UPDATE': 'Campos e locais de actualização',
		'GEOMETRY.ADD.REGENERATION_NEEDED': 'Todos os dados subjacentes precisam ser atualizados para serem atribuídos corretamente após a adição de uma nova geometria. Você deseja atualizar os dados agora?',
		'GEOMETRY.CLICK_TO_SAVE': 'Para salvar, clique na mapa.',
		'GPS': 'GPS',
		'GPS.GPS': 'GPS interno',
		'GPS.LP': 'Última posição conhecida',
		'GPS.RTK': 'RTK',
		'GPS.RTK_H': 'RTK (alta precisão)',
		'GPS.STATUS': 'Estado do GPS',
		'GPS_HITCH_DISTANCE.IMPLEMENT.INFO': 'For recording the machine track correctly you need to input the distance between the hitch (A) and the point of application of the implement (B). The distance is measured in cm.',
		'GPS_HITCH_DISTANCE.MACHINE.INFO': 'For recording the machine track correctly you need to input the distance between the GPS receiver (A) and the hitch of the machine (B). The distance is measured in cm.',
		'GPS_TO_HITCH_DISTANCE': 'Distância entre o GPS e o engate',
		'HARDWARE': 'Hardware',
		'HARDWARE.SETUP.PRINT_STICKER': 'Imprimir adesivo de hardware',
		'HARDWARE.SETUP.PRINT_STICKER_PACKAGING': 'Imprimir adesivo de embalagem',
		'HARDWARE.SETUP.RESET_DEVICE': 'Redefinir dispositivo',
		'HARDWARE.SETUP.SET_SERIAL': 'Definir serial',
		'HEADLAND.PASSES': 'Headland passes',
		'HELPER_MODEL_TEXT': 'Modelo de acordo com a entrada',
		'HINT_MARKERS.SHOW': 'Mostrar marcadores de dicas',
		'HITCH_TO_APPLICATION_DISTANCE': 'Distância entre o engate e a aplicação',
		'HOME': 'Bem-vindo',
		'HOME.CONTACTREPLY1': 'Então, por favor, contacte-nos pelo telefone',
		'HOME.CONTACTREPLY2': 'ou nos escreva um e-mail para',
		'HOME.INTRODUCTORY_VIDEOS': 'Vídeos introdutórios',
		'HOME.NEWSINFO1': 'Todas as novidades e informações interessantes sobre gestão de frotas e rastreamento de veículos podem ser encontradas no nosso',
		'HOME.NEWSINFO2': 'ou em nosso',
		'HOME.PROFILEEXPLANATION': 'Em \"Meu perfil\" você pode ajustar os seus dados pesoais, mudar seu e-mail e a sua senha.',
		'HOME.QUESTIONSYSTEM': 'Você tem perguntas sobre o nosso sistema?',
		'HOME.TITLE': 'Bem-vindo',
		'HOME.WELCOMEAREA': 'Bem-vindo à sua Area!',
		'IDLE': 'Ocioso',
		'IGNORE': 'Ignorar',
		'IMPLEMENT': 'Alfaia',
		'IMPLEMENT.ADD': 'Adicionar alfaia',
		'IMPLEMENT.ADD.SUCCESS': 'Alfaia adicionada com sucesso',
		'IMPLEMENT.CLASS': 'Classe da alfaia',
		'IMPLEMENT.DELETE.QUESTION': 'Deseja excluir a alfaia?',
		'IMPLEMENT.DELETE.SUCCESS': 'Alfaia removida.',
		'IMPLEMENT.DETAILS': 'Detalhes da alfaia',
		'IMPLEMENT.EDIT': 'Editar alfaia',
		'IMPLEMENT.EDIT.SUCCESS': 'Alfaia editada com sucesso',
		'IMPLEMENT.FIXED': 'Alfaia fixa',
		'IMPLEMENT.NO': 'Viagem em alfaia',
		'IMPLEMENT.PROCESS.0': 'Viagem sem alfaia',
		'IMPLEMENT.PROCESS.1': 'Prensa de fardos redondos',
		'IMPLEMENT.PROCESS.10': 'Rolo',
		'IMPLEMENT.PROCESS.11': 'Semeadura',
		'IMPLEMENT.PROCESS.12': 'Plantação',
		'IMPLEMENT.PROCESS.13': 'Fertilização',
		'IMPLEMENT.PROCESS.14': 'Aspersão',
		'IMPLEMENT.PROCESS.15': 'Irrigação',
		'IMPLEMENT.PROCESS.16': 'Corte de grama',
		'IMPLEMENT.PROCESS.17': 'Torneamento da relva',
		'IMPLEMENT.PROCESS.18': 'Transporte',
		'IMPLEMENT.PROCESS.19': 'Varredura',
		'IMPLEMENT.PROCESS.2': 'Prensa de fardos quadrados',
		'IMPLEMENT.PROCESS.20': 'Lavagem da neve',
		'IMPLEMENT.PROCESS.21': 'Espalhamento de sal',
		'IMPLEMENT.PROCESS.22': 'Capinar',
		'IMPLEMENT.PROCESS.23': 'Fertilização mineral',
		'IMPLEMENT.PROCESS.24': 'Bombagem de adubo líquido',
		'IMPLEMENT.PROCESS.25': 'Mistura de lamas',
		'IMPLEMENT.PROCESS.26': 'Colocação de batatas',
		'IMPLEMENT.PROCESS.27': 'Arrancamento',
		'IMPLEMENT.PROCESS.28': 'Separação',
		'IMPLEMENT.PROCESS.29': 'Formador de camalhão',
		'IMPLEMENT.PROCESS.3': 'Bobinagem da prensa',
		'IMPLEMENT.PROCESS.30': 'Cobertura Haulm',
		'IMPLEMENT.PROCESS.31': 'Leiras',
		'IMPLEMENT.PROCESS.32': 'Arrebatar',
		'IMPLEMENT.PROCESS.33': 'Arrebatar',
		'IMPLEMENT.PROCESS.34': 'Picagem',
		'IMPLEMENT.PROCESS.35': 'Varredura',
		'IMPLEMENT.PROCESS.36': 'Moagem de neve',
		'IMPLEMENT.PROCESS.37': 'Movimentação do tanque de adubo',
		'IMPLEMENT.PROCESS.38': 'Encanteirar',
		'IMPLEMENT.PROCESS.39': 'Alimentação',
		'IMPLEMENT.PROCESS.4': 'Embalagem do fardo',
		'IMPLEMENT.PROCESS.40': 'Transportar madeira',
		'IMPLEMENT.PROCESS.41': 'Serração de madeira',
		'IMPLEMENT.PROCESS.42': 'Corte de lenha',
		'IMPLEMENT.PROCESS.43': 'Destocamento',
		'IMPLEMENT.PROCESS.44': 'Carregamento de material a granel',
		'IMPLEMENT.PROCESS.45': 'Carregamento de paletes',
		'IMPLEMENT.PROCESS.46': 'Carregamento de fardos',
		'IMPLEMENT.PROCESS.47': 'Converter moinho CCM',
		'IMPLEMENT.PROCESS.48': 'Movimentação',
		'IMPLEMENT.PROCESS.49': 'Peso dianteiro/traseiro',
		'IMPLEMENT.PROCESS.5': 'Arado',
		'IMPLEMENT.PROCESS.50': 'Debulha',
		'IMPLEMENT.PROCESS.51': 'Trituração',
		'IMPLEMENT.PROCESS.52': 'Enfardamento de fardos de alta pressão',
		'IMPLEMENT.PROCESS.53': 'Desfolhado',
		'IMPLEMENT.PROCESS.54': 'Aplainamento',
		'IMPLEMENT.PROCESS.55': 'Lavoura',
		'IMPLEMENT.PROCESS.56': 'Asseio',
		'IMPLEMENT.PROCESS.57': 'Trabalho de montagem',
		'IMPLEMENT.PROCESS.58': 'Entra no comboio',
		'IMPLEMENT.PROCESS.59': 'Carregamento e descarregamento',
		'IMPLEMENT.PROCESS.6': 'Cultivo',
		'IMPLEMENT.PROCESS.60': 'Lavagem',
		'IMPLEMENT.PROCESS.61': 'Compactação',
		'IMPLEMENT.PROCESS.7': 'Grade',
		'IMPLEMENT.PROCESS.8': 'Cultivo profundo',
		'IMPLEMENT.PROCESS.9': 'Moagem',
		'IMPLEMENT.PROCESS.deadhead': 'Viagem sem alfaia',
		'IMPLEMENT.REMOVE': 'Retirar a alfaia',
		'IMPLEMENT.RESOURCE.0': 'Indefinido',
		'IMPLEMENT.RESOURCE.1': 'Forragem',
		'IMPLEMENT.RESOURCE.10': 'Adubo sólido',
		'IMPLEMENT.RESOURCE.11': 'Adubo líquido',
		'IMPLEMENT.RESOURCE.12': 'Composto',
		'IMPLEMENT.RESOURCE.13': 'Biofertilizante',
		'IMPLEMENT.RESOURCE.14': 'Cavaco',
		'IMPLEMENT.RESOURCE.15': 'Milho',
		'IMPLEMENT.RESOURCE.16': 'Girassóis',
		'IMPLEMENT.RESOURCE.17': 'Sorgo',
		'IMPLEMENT.RESOURCE.18': 'Centeio',
		'IMPLEMENT.RESOURCE.19': 'Triticale',
		'IMPLEMENT.RESOURCE.2': 'Silagem de grama',
		'IMPLEMENT.RESOURCE.20': 'Trigo',
		'IMPLEMENT.RESOURCE.21': 'Fava',
		'IMPLEMENT.RESOURCE.22': 'Ervilhas',
		'IMPLEMENT.RESOURCE.23': 'Grama do campo',
		'IMPLEMENT.RESOURCE.24': 'Trevo',
		'IMPLEMENT.RESOURCE.25': 'Cevada',
		'IMPLEMENT.RESOURCE.26': 'Aveia',
		'IMPLEMENT.RESOURCE.27': 'Espelta',
		'IMPLEMENT.RESOURCE.28': 'Camelina',
		'IMPLEMENT.RESOURCE.29': 'Linho',
		'IMPLEMENT.RESOURCE.3': 'GPS',
		'IMPLEMENT.RESOURCE.30': 'Colza',
		'IMPLEMENT.RESOURCE.31': 'Soja',
		'IMPLEMENT.RESOURCE.32': 'Cultura secundAria',
		'IMPLEMENT.RESOURCE.33': 'Beterrabas',
		'IMPLEMENT.RESOURCE.34': 'Batatas',
		'IMPLEMENT.RESOURCE.35': 'Miscanto',
		'IMPLEMENT.RESOURCE.36': 'Tupinambo',
		'IMPLEMENT.RESOURCE.37': 'Legumes',
		'IMPLEMENT.RESOURCE.38': 'Morangos',
		'IMPLEMENT.RESOURCE.39': 'Fertilizante líquido',
		'IMPLEMENT.RESOURCE.4': 'Feno',
		'IMPLEMENT.RESOURCE.40': 'Cal',
		'IMPLEMENT.RESOURCE.41': 'Fosfato diamônico',
		'IMPLEMENT.RESOURCE.42': 'Fertilizante granulado',
		'IMPLEMENT.RESOURCE.43': 'Ureia',
		'IMPLEMENT.RESOURCE.44': 'Diesel',
		'IMPLEMENT.RESOURCE.45': 'Adblue/Arla',
		'IMPLEMENT.RESOURCE.46': 'Terra',
		'IMPLEMENT.RESOURCE.47': 'Pesticidas',
		'IMPLEMENT.RESOURCE.48': 'Outros',
		'IMPLEMENT.RESOURCE.49': 'Água',
		'IMPLEMENT.RESOURCE.5': 'CCM',
		'IMPLEMENT.RESOURCE.50': 'Mistura de rações',
		'IMPLEMENT.RESOURCE.6': 'Grão de milho',
		'IMPLEMENT.RESOURCE.7': 'Palha',
		'IMPLEMENT.RESOURCE.8': 'Silagem de milho',
		'IMPLEMENT.RESOURCE.9': 'Cereais',
		'IMPLEMENT.TYPE': 'Tipo de Alfaia',
		'IMPLEMENT.TYPE.1': 'Enfardadeiras/Empacotadoras',
		'IMPLEMENT.TYPE.10': 'Reboque de Transporte',
		'IMPLEMENT.TYPE.10_1': 'Caçamba basculante trilateral',
		'IMPLEMENT.TYPE.10_10': 'Prancha baixa',
		'IMPLEMENT.TYPE.10_11': 'Reboque com gancho de elevação',
		'IMPLEMENT.TYPE.10_12': 'Vagão de gado',
		'IMPLEMENT.TYPE.10_13': 'Carreta para semirreboque',
		'IMPLEMENT.TYPE.10_14': 'Camiões-cisterna/silo',
		'IMPLEMENT.TYPE.10_2': 'Caçamba basculante',
		'IMPLEMENT.TYPE.10_3': 'Vagão de sobrecarga',
		'IMPLEMENT.TYPE.10_4': 'Caminhão plataforma',
		'IMPLEMENT.TYPE.10_5': 'Vagão de carga/silagem',
		'IMPLEMENT.TYPE.10_6': 'Vagão forrageiro',
		'IMPLEMENT.TYPE.10_7': 'Reboque plataforma',
		'IMPLEMENT.TYPE.10_8': 'Caçamba de empurre',
		'IMPLEMENT.TYPE.10_9': 'Semi-reboque tanque de adubo líquido',
		'IMPLEMENT.TYPE.11': 'Tecnologia de Alimentação',
		'IMPLEMENT.TYPE.11_1': 'Vagão misturador',
		'IMPLEMENT.TYPE.11_2': 'Vagão distribuidor',
		'IMPLEMENT.TYPE.11_3': 'Dispositivo sem nome/fornecedor',
		'IMPLEMENT.TYPE.12': 'Tecnologia Florestal',
		'IMPLEMENT.TYPE.12_1': 'Reboque traseiro',
		'IMPLEMENT.TYPE.12_2': 'Serrador de lenha',
		'IMPLEMENT.TYPE.12_3': 'Processadora de lenha',
		'IMPLEMENT.TYPE.12_4': 'Rachador de lenha',
		'IMPLEMENT.TYPE.12_5': 'Destocador',
		'IMPLEMENT.TYPE.12_6': 'Guincho florestal',
		'IMPLEMENT.TYPE.12_7': 'Triturador florestal',
		'IMPLEMENT.TYPE.12_8': 'Picador de tronco',
		'IMPLEMENT.TYPE.12_8_1': 'Picador a disco - fixo',
		'IMPLEMENT.TYPE.12_8_2': 'Picador a disco - anexado',
		'IMPLEMENT.TYPE.12_8_3': 'Picador a tambor - fixo',
		'IMPLEMENT.TYPE.12_8_4': 'Picador a tambor - anexado',
		'IMPLEMENT.TYPE.12_8_5': 'Picador a tambor - anexado com motor próprio',
		'IMPLEMENT.TYPE.12_9': 'Cortador hidráulico de bordas',
		'IMPLEMENT.TYPE.13': 'Tecnologia Municipal',
		'IMPLEMENT.TYPE.13_1': 'Varredoras',
		'IMPLEMENT.TYPE.13_10': 'Dispositivo de manutenção do traçado',
		'IMPLEMENT.TYPE.13_11': 'Fresadora de banquetes',
		'IMPLEMENT.TYPE.13_12': 'Agitador de sal - montado',
		'IMPLEMENT.TYPE.13_13': 'Carregador',
		'IMPLEMENT.TYPE.13_14': 'Dispositivo de lavagem',
		'IMPLEMENT.TYPE.13_15': 'Dispositivo de irrigação',
		'IMPLEMENT.TYPE.13_16': 'Plataforma de trabalho',
		'IMPLEMENT.TYPE.13_17': 'Trituradores de superfície',
		'IMPLEMENT.TYPE.13_18': 'Estabilizador dianteiro',
		'IMPLEMENT.TYPE.13_18_1': 'Cabeça de corte',
		'IMPLEMENT.TYPE.13_18_2': 'Cabeça de trituração',
		'IMPLEMENT.TYPE.13_18_3': 'Aparador de sebes',
		'IMPLEMENT.TYPE.13_18_4': 'Cesto de limpeza',
		'IMPLEMENT.TYPE.13_18_5': 'Ancinho',
		'IMPLEMENT.TYPE.13_19': 'Centro de manobra / super-estrutura',
		'IMPLEMENT.TYPE.13_19_1': 'Cabeça de corte',
		'IMPLEMENT.TYPE.13_19_2': 'Cabeça de trituração',
		'IMPLEMENT.TYPE.13_19_3': 'Aparador de sebes',
		'IMPLEMENT.TYPE.13_19_4': 'Cesto de limpeza',
		'IMPLEMENT.TYPE.13_19_5': 'Ancinho',
		'IMPLEMENT.TYPE.13_1_1': 'Dianteira',
		'IMPLEMENT.TYPE.13_1_2': 'Traseira',
		'IMPLEMENT.TYPE.13_1_3': 'Estrutura',
		'IMPLEMENT.TYPE.13_2': 'Limpa-neves',
		'IMPLEMENT.TYPE.13_20': 'Acessório traseiro de outrigger',
		'IMPLEMENT.TYPE.13_20_1': 'Cabeça de corte',
		'IMPLEMENT.TYPE.13_20_2': 'Cabeça de trituração',
		'IMPLEMENT.TYPE.13_20_3': 'Aparador de sebes',
		'IMPLEMENT.TYPE.13_20_4': 'Cesto de limpeza',
		'IMPLEMENT.TYPE.13_20_5': 'Ancinho',
		'IMPLEMENT.TYPE.13_21': 'Aspirador de folhas',
		'IMPLEMENT.TYPE.13_22': 'Compactador de banquete / compactador de placa',
		'IMPLEMENT.TYPE.13_3': 'Limpa-neves - cunha',
		'IMPLEMENT.TYPE.13_4': 'Soprador de neve',
		'IMPLEMENT.TYPE.13_5': 'Soprador de neve - fixo',
		'IMPLEMENT.TYPE.13_6': 'Soprador de neve - anexado',
		'IMPLEMENT.TYPE.13_7': 'Gadanheira condicionadora',
		'IMPLEMENT.TYPE.13_8': 'Segadeira',
		'IMPLEMENT.TYPE.13_9': 'Cortador de grama',
		'IMPLEMENT.TYPE.14': 'Operações de Trabalho Frontal',
		'IMPLEMENT.TYPE.14_1': 'PA carregadeira',
		'IMPLEMENT.TYPE.14_2': 'Concha dianteira',
		'IMPLEMENT.TYPE.14_3': 'Garfo Pallet',
		'IMPLEMENT.TYPE.14_4': 'Pinça para fardo',
		'IMPLEMENT.TYPE.14_5': 'Garfo para fardo',
		'IMPLEMENT.TYPE.14_6': 'Garfo para silagem aberto/fechado',
		'IMPLEMENT.TYPE.14_7': 'Plataforma de trabalho',
		'IMPLEMENT.TYPE.14_8': 'Garfo de estrume',
		'IMPLEMENT.TYPE.15': 'Alfaia de colheita',
		'IMPLEMENT.TYPE.15_1': 'Barra de corte',
		'IMPLEMENT.TYPE.15_1_1': 'Barra de corte - padrão',
		'IMPLEMENT.TYPE.15_1_2': 'Barra de corte - dobrAvel',
		'IMPLEMENT.TYPE.15_2': 'Colheitadeira de milho',
		'IMPLEMENT.TYPE.15_2_1': 'Colheitadeira de milho - padrão',
		'IMPLEMENT.TYPE.15_3': 'plataforma de corte para milho',
		'IMPLEMENT.TYPE.15_4': 'GPS attachment',
		'IMPLEMENT.TYPE.15_5': 'Pick-Up',
		'IMPLEMENT.TYPE.15_6': 'Fixação de limpeza',
		'IMPLEMENT.TYPE.15_7': 'Sistema de admissão',
		'IMPLEMENT.TYPE.15_8': 'Coleta de faixas',
		'IMPLEMENT.TYPE.16': 'Outros',
		'IMPLEMENT.TYPE.16_1': 'Moinhos de grãos CCM',
		'IMPLEMENT.TYPE.16_2': 'Peso frontal',
		'IMPLEMENT.TYPE.16_3': 'Peso traseiro',
		'IMPLEMENT.TYPE.16_4': 'Lâmina Frontal',
		'IMPLEMENT.TYPE.17': 'Pomar e vinha',
		'IMPLEMENT.TYPE.17_1': 'Arado de limpeza',
		'IMPLEMENT.TYPE.17_2': 'Máquina de plantar',
		'IMPLEMENT.TYPE.17_3': 'Desfoliador',
		'IMPLEMENT.TYPE.17_4': 'Fresadora de porta-enxertos',
		'IMPLEMENT.TYPE.18': 'Cultivo vegetais',
		'IMPLEMENT.TYPE.18_1': 'Colhedora de cenouras',
		'IMPLEMENT.TYPE.18_2': 'Colhedora de cebolas',
		'IMPLEMENT.TYPE.18_4': 'Colhedora de lâmpadas',
		'IMPLEMENT.TYPE.18_5': 'Colhedora de alho francês',
		'IMPLEMENT.TYPE.19': 'Tecnologia da beterraba sacarina',
		'IMPLEMENT.TYPE.19_1': 'Colhedora de beterraba sacarina - Colhedora de bunker',
		'IMPLEMENT.TYPE.19_1_1': 'Colheitadeira de bunker',
		'IMPLEMENT.TYPE.19_1_2': 'Sobrecarregador',
		'IMPLEMENT.TYPE.1_1': 'Enfardadeira de fardos redondos',
		'IMPLEMENT.TYPE.1_2': 'Enfardadeira de fardos quadrados',
		'IMPLEMENT.TYPE.1_3': 'Combinação enfardador - atador',
		'IMPLEMENT.TYPE.1_4': 'Empacotadora de fardos',
		'IMPLEMENT.TYPE.1_5': 'Enfardadeira de alta densidade',
		'IMPLEMENT.TYPE.2': 'Lavoura',
		'IMPLEMENT.TYPE.2_1': 'Arado',
		'IMPLEMENT.TYPE.2_10': 'Fresadora',
		'IMPLEMENT.TYPE.2_10_1': 'Perfilhador rotativo montado',
		'IMPLEMENT.TYPE.2_10_2': 'Perfilhador rotativo seguido',
		'IMPLEMENT.TYPE.2_11': 'Embalador frontal',
		'IMPLEMENT.TYPE.2_12': 'Rolo',
		'IMPLEMENT.TYPE.2_12_1': 'Rolo montado',
		'IMPLEMENT.TYPE.2_12_2': 'Rolo de rastos',
		'IMPLEMENT.TYPE.2_13': 'Grades rotativas',
		'IMPLEMENT.TYPE.2_13_1': 'Grades rotativas montadas',
		'IMPLEMENT.TYPE.2_13_2': 'Grades rotativas seguidas',
		'IMPLEMENT.TYPE.2_14': 'Cultivador rotativo',
		'IMPLEMENT.TYPE.2_14_1': 'Cultivador rotativo montado',
		'IMPLEMENT.TYPE.2_14_2': 'Cultivador rotativo rastreado',
		'IMPLEMENT.TYPE.2_15': 'Combinação de leito de semente',
		'IMPLEMENT.TYPE.2_15_1': 'Combinação de cama de sementes montada',
		'IMPLEMENT.TYPE.2_15_2': 'Combinação de leito de sementes arrastado',
		'IMPLEMENT.TYPE.2_16': 'Prensas',
		'IMPLEMENT.TYPE.2_17': 'Raspadores',
		'IMPLEMENT.TYPE.2_17_1': 'Raspadores montados',
		'IMPLEMENT.TYPE.2_17_2': 'Raspadores de rastos',
		'IMPLEMENT.TYPE.2_18': 'Grade de palha montada',
		'IMPLEMENT.TYPE.2_18_1': 'Grade de palha montada',
		'IMPLEMENT.TYPE.2_18_2': 'Grade de palha de palha arrastada',
		'IMPLEMENT.TYPE.2_19': 'Outros cultivadores',
		'IMPLEMENT.TYPE.2_19_1': 'Montar mais cultivadores',
		'IMPLEMENT.TYPE.2_19_2': 'Mais cultivadores seguidos',
		'IMPLEMENT.TYPE.2_1_1': 'Arado - fixo',
		'IMPLEMENT.TYPE.2_1_2': 'Arado - semi-montado',
		'IMPLEMENT.TYPE.2_1_3': 'Arado - semi-montado (em terra)',
		'IMPLEMENT.TYPE.2_2': 'Cultivador',
		'IMPLEMENT.TYPE.2_20': 'Outros cultivadores',
		'IMPLEMENT.TYPE.2_2_1': 'Cultivador - fixo',
		'IMPLEMENT.TYPE.2_2_2': 'Cultivador - semi-montado',
		'IMPLEMENT.TYPE.2_3': 'Grade de discos',
		'IMPLEMENT.TYPE.2_3_1': 'Grade de discos - fixa',
		'IMPLEMENT.TYPE.2_3_2': 'Grade de discos - semi-montada',
		'IMPLEMENT.TYPE.2_4': 'Grade de discos curtos',
		'IMPLEMENT.TYPE.2_4_1': 'Grade de discos compactos montados',
		'IMPLEMENT.TYPE.2_4_2': 'Grade de discos compactos trilhados',
		'IMPLEMENT.TYPE.2_5': 'Subsolador',
		'IMPLEMENT.TYPE.2_5_1': 'Desaperte profundo montado',
		'IMPLEMENT.TYPE.2_5_2': 'Desapertos profundos seguidos',
		'IMPLEMENT.TYPE.2_6': 'Enxada rotativa',
		'IMPLEMENT.TYPE.2_6_1': 'Máquina de espalhar montada',
		'IMPLEMENT.TYPE.2_6_2': 'Máquina de espadelar com rasto',
		'IMPLEMENT.TYPE.2_7': 'Grade rotativa',
		'IMPLEMENT.TYPE.2_7_1': 'Grade rotativa montada',
		'IMPLEMENT.TYPE.2_7_2': 'Grade rotativa trilhada',
		'IMPLEMENT.TYPE.2_8': 'Escarificador',
		'IMPLEMENT.TYPE.2_8_1': 'Enxada rotativa montada',
		'IMPLEMENT.TYPE.2_8_2': 'Enxada rotativa rastreada',
		'IMPLEMENT.TYPE.2_9': 'Grade alternada',
		'IMPLEMENT.TYPE.2_9_1': 'Grade de reciprocidade montada',
		'IMPLEMENT.TYPE.2_9_2': 'Grinalda de reciprocidade trilhada',
		'IMPLEMENT.TYPE.3': 'Tecnologia de Semeadura/Plantio',
		'IMPLEMENT.TYPE.3_1': 'Semeadora mecanica',
		'IMPLEMENT.TYPE.3_1_1': 'Semeadora fixa',
		'IMPLEMENT.TYPE.3_1_2': 'Semeadora anexada',
		'IMPLEMENT.TYPE.3_1_3': 'Combinação de semeadora fixa',
		'IMPLEMENT.TYPE.3_1_4': 'Combinação de semeadora anexada',
		'IMPLEMENT.TYPE.3_2': 'Semeadora pneumática',
		'IMPLEMENT.TYPE.3_2_1': 'Semeadora montada',
		'IMPLEMENT.TYPE.3_2_2': 'Semeadora anexada',
		'IMPLEMENT.TYPE.3_2_3': 'Combinação de semeadora fixa',
		'IMPLEMENT.TYPE.3_2_4': 'Combinação de semeadora anexada',
		'IMPLEMENT.TYPE.3_3': 'Semeadora mecânica de precisão',
		'IMPLEMENT.TYPE.3_3_1': 'Semeadora montada',
		'IMPLEMENT.TYPE.3_3_2': 'Semeadora anexada',
		'IMPLEMENT.TYPE.3_3_3': 'Combinação de semeadora fixa',
		'IMPLEMENT.TYPE.3_3_4': 'Combinação de semeadora  anexada',
		'IMPLEMENT.TYPE.3_4': 'Semeadora pneumática de precisão',
		'IMPLEMENT.TYPE.3_4_1': 'Semeadora montada',
		'IMPLEMENT.TYPE.3_4_2': 'Semeadora anexada',
		'IMPLEMENT.TYPE.3_4_3': 'Combinação de semeadora fixa',
		'IMPLEMENT.TYPE.3_4_4': 'Combinação de semeadora anexada',
		'IMPLEMENT.TYPE.3_5': 'Semeadora direta',
		'IMPLEMENT.TYPE.3_5_1': 'Semeador direto montado',
		'IMPLEMENT.TYPE.3_5_2': 'Semeador direto anexado',
		'IMPLEMENT.TYPE.3_6': 'Semeadora direta individual',
		'IMPLEMENT.TYPE.3_6_1': 'Semeador directo de grão único montado',
		'IMPLEMENT.TYPE.3_6_2': 'Semeador directo de grão único ligado',
		'IMPLEMENT.TYPE.3_7': 'Plantadeira',
		'IMPLEMENT.TYPE.3_7_1': 'Plantador montado',
		'IMPLEMENT.TYPE.3_7_2': 'Plantador - em anexo',
		'IMPLEMENT.TYPE.3_8': 'Semeadora de pastagens',
		'IMPLEMENT.TYPE.3_8_1': 'Superintendente de pastagem anexado',
		'IMPLEMENT.TYPE.3_8_2': 'Semeadora de pastagem anexada',
		'IMPLEMENT.TYPE.3_9': 'Tanque dianteiro',
		'IMPLEMENT.TYPE.4': 'Tecnologia de Fertilização',
		'IMPLEMENT.TYPE.4_1': 'Espalhador de adubo fixo',
		'IMPLEMENT.TYPE.4_2': 'Espalhador de adubo anexado',
		'IMPLEMENT.TYPE.5': 'Tecnologia de Proteção de Plantas',
		'IMPLEMENT.TYPE.5_1': 'Pulverizador fixo',
		'IMPLEMENT.TYPE.5_2': 'Puleverizador anexado',
		'IMPLEMENT.TYPE.5_3': 'Sachador/escarificador',
		'IMPLEMENT.TYPE.5_3_1': 'Enxada montada',
		'IMPLEMENT.TYPE.5_3_2': 'Enxada de reboque',
		'IMPLEMENT.TYPE.5_4': 'Capinadores',
		'IMPLEMENT.TYPE.5_4_1': 'Triturador montado',
		'IMPLEMENT.TYPE.5_4_2': 'Trituradores de ervas daninhas seguidas',
		'IMPLEMENT.TYPE.6': 'Tecnologia de Adubo Líquido',
		'IMPLEMENT.TYPE.6_1': 'Espalhador de adubo/composto',
		'IMPLEMENT.TYPE.6_2': 'Tanque de adubo líquido',
		'IMPLEMENT.TYPE.6_2_1': 'Placa de impacto',
		'IMPLEMENT.TYPE.6_2_2': 'Distribuidor de adubo líquido',
		'IMPLEMENT.TYPE.6_2_3': 'Espalhador de sapatos de arrasto',
		'IMPLEMENT.TYPE.6_2_4': 'Cultivador de injecção',
		'IMPLEMENT.TYPE.6_2_5': 'Grade de disco de injecção',
		'IMPLEMENT.TYPE.6_2_6': 'Cortador de pastagens',
		'IMPLEMENT.TYPE.6_2_7': 'Striptill Injektor',
		'IMPLEMENT.TYPE.6_2_8': 'Distribuidor giratório',
		'IMPLEMENT.TYPE.6_3': 'Bombas de adubo líquido',
		'IMPLEMENT.TYPE.6_4': 'Misturador de adubo líquido',
		'IMPLEMENT.TYPE.6_5': 'Container de adubo líquido',
		'IMPLEMENT.TYPE.6_6': 'Sistema de mangueiras',
		'IMPLEMENT.TYPE.6_6_1': 'Distribuidor de mangueira de arrastamento',
		'IMPLEMENT.TYPE.6_6_2': 'Distribuidor de sapatos de arrasto',
		'IMPLEMENT.TYPE.6_6_3': 'Injector de disco de chorume',
		'IMPLEMENT.TYPE.6_6_4': 'Cultivador de chorume',
		'IMPLEMENT.TYPE.6_6_5': 'Grade de disco de chorume',
		'IMPLEMENT.TYPE.6_6_6': 'Injector de chorume',
		'IMPLEMENT.TYPE.6_6_7': 'Distribuidor giratório',
		'IMPLEMENT.TYPE.7': 'Tecnologia de Irrigação',
		'IMPLEMENT.TYPE.7_1': 'Maquina irrigadora com carrinho aspersor',
		'IMPLEMENT.TYPE.7_2': 'Maquina irrigador acom aspersor único',
		'IMPLEMENT.TYPE.8': 'Tecnologia de Batatas',
		'IMPLEMENT.TYPE.8_1': 'Tecnologia de batatas',
		'IMPLEMENT.TYPE.8_1_1': 'Maquina de plantio sem grade rotativa/cultivador',
		'IMPLEMENT.TYPE.8_1_2': 'Maquina de plantio com grade rotativa/cultivador',
		'IMPLEMENT.TYPE.8_1_3': 'Plantadora sem perfilhador rotativo (rastreado)',
		'IMPLEMENT.TYPE.8_1_4': 'Plantadora com lavrador rotativo (montada)',
		'IMPLEMENT.TYPE.8_2': 'Plantadores de Linhas',
		'IMPLEMENT.TYPE.8_3': 'Colhedora de batatas',
		'IMPLEMENT.TYPE.8_4': 'Colhedora de batatas',
		'IMPLEMENT.TYPE.8_5': 'Encanteirador',
		'IMPLEMENT.TYPE.8_6': 'Separador',
		'IMPLEMENT.TYPE.8_7': 'Formador de camalhão',
		'IMPLEMENT.TYPE.8_8': 'Triturador de folhas',
		'IMPLEMENT.TYPE.9': 'Equipamento de Pastagem',
		'IMPLEMENT.TYPE.9_1': 'Cortador de grama',
		'IMPLEMENT.TYPE.9_1_1': 'Cortador de grama com recolhedor',
		'IMPLEMENT.TYPE.9_1_2': 'Cortador de grama sem recolhedor',
		'IMPLEMENT.TYPE.9_1_3': 'Cortador de tambor com condicionador (montado)',
		'IMPLEMENT.TYPE.9_1_4': 'Cortador de tambor sem amaciador (rastreado)',
		'IMPLEMENT.TYPE.9_2': 'Barras de corte',
		'IMPLEMENT.TYPE.9_2_1': 'Barras de corte com recolhedor',
		'IMPLEMENT.TYPE.9_2_2': 'Barras de corte sem recolhedor',
		'IMPLEMENT.TYPE.9_2_3': 'Cortador de disco com condicionador (montado)',
		'IMPLEMENT.TYPE.9_2_4': 'Cortador de relva de disco sem condicionador (rastreado)',
		'IMPLEMENT.TYPE.9_3': 'Ancinho enleirador/espalhador de feno',
		'IMPLEMENT.TYPE.9_3_1': 'Kreiselheuer/-wender angebaut',
		'IMPLEMENT.TYPE.9_3_2': 'Kreiselheuer/-wender angehängt',
		'IMPLEMENT.TYPE.9_4': 'Ancinho de feno',
		'IMPLEMENT.TYPE.9_4_1': 'Ancinho de rotor único',
		'IMPLEMENT.TYPE.9_4_2': 'Ancinho de dois rotores com entrega lateral',
		'IMPLEMENT.TYPE.9_4_3': 'Ancinho de dois rotores sem entrega central',
		'IMPLEMENT.TYPE.9_4_4': 'Ancinho de quatro rotores',
		'IMPLEMENT.TYPE.9_4_5': 'enleirador com esteira',
		'IMPLEMENT.TYPE.9_4_6': 'Ancinhos rotativos',
		'IMPLEMENT.TYPE.9_5': 'Grades de mola',
		'IMPLEMENT.TYPE.9_6': 'Grade de corrente de arrasto',
		'IMPLEMENT.TYPE.9_7': 'Rolo compactador',
		'IMPLEMENT.TYPE.9_8': 'Rolo triturador',
		'IMPLEMENTS': 'Alfaias',
		'IMPLEMENTS.ALL': 'Todos os utensílios',
		'IMPLEMENTS.DEACTIVATE.FAILURE': 'Alguns dos implementos não puderam ser desativados.',
		'IMPLEMENTS.DEACTIVATE.QUESTION': 'Você realmente deseja desativar os implementos selecionados?',
		'IMPLEMENTS.DEACTIVATE.SUCCESS': 'Implementos desativados com sucesso',
		'IMPLEMENTS.DELETE.FAILURE': 'Alguns das alfaias não puderam ser eliminados.',
		'IMPLEMENTS.DELETE.QUESTION': '¿Quer realmente apagar os utensílios seleccionados?',
		'IMPLEMENTS.DELETE.SUCCESS': 'Foram eliminados as alfaias',
		'IMPLEMENTS.MANAGEMENT': 'Gestão de alfaias',
		'IMPLEMENTS.NO': 'Viagem sem alfaias',
		'IMPLEMENTS.NOT_SELECTED': 'Nenhuma alfaia selecionada',
		'IMPLEMENTS.REACTIVATE.FAILURE': 'Alguns dos implementos não puderam ser reativados.',
		'IMPLEMENTS.REACTIVATE.QUESTION': 'Você realmente deseja reativar os implementos selecionados?',
		'IMPLEMENTS.REACTIVATE.SUCCESS': 'Implementos reativados com sucesso',
		'IMPLEMENTS.SELECTED': 'Utensílios seleccionados',
		'IMPLEMENT_SCAN_DISABLED': 'Implementar o scan de beacon inactive',
		'IMPORT': 'Importar',
		'INACTIVE': 'Inactivo',
		'INDIVIDUAL_LABELING': 'Rotulagem personalizada',
		'INFO': 'Informações',
		'INTERPOLATION.MAP': 'Mapa de interpolação',
		'INTERPOLATION.MAP.SETTINGS': 'Configurações do mapa de interpolação',
		'IO_BOX_ACTIVATED': 'IOBox ativa',
		'ISOBUS.DDI.1': 'Volume de ponto de ajuste por taxa de aplicação de área',
		'ISOBUS.DDI.10': 'Taxa máxima de aplicação de massa por área',
		'ISOBUS.DDI.100': 'Contaminação de culturas',
		'ISOBUS.DDI.101': 'Largura de fardos de ponto de ajuste',
		'ISOBUS.DDI.102': 'Largura real do fardo',
		'ISOBUS.DDI.103': 'Largura de fardo por defeito',
		'ISOBUS.DDI.104': 'Largura mínima dos fardos',
		'ISOBUS.DDI.105': 'Largura máxima dos fardos',
		'ISOBUS.DDI.106': 'Ponto de ajuste da altura dos fardos ',
		'ISOBUS.DDI.107': 'Altura real do fardo',
		'ISOBUS.DDI.108': 'Altura dos fardos por defeito',
		'ISOBUS.DDI.109': 'Altura mínima do fardo',
		'ISOBUS.DDI.11': 'Ponto de ajuste da taxa de aplicação de contagem por área',
		'ISOBUS.DDI.110': 'Altura máxima do fardo',
		'ISOBUS.DDI.111': 'Ponto de ajuste do tamanho do fardo',
		'ISOBUS.DDI.112': 'Tamanho real do fardo',
		'ISOBUS.DDI.113': 'Tamanho de fardo por defeito',
		'ISOBUS.DDI.114': 'Tamanho mínimo do fardo',
		'ISOBUS.DDI.115': 'Tamanho máximo do fardo',
		'ISOBUS.DDI.116': 'Área total',
		'ISOBUS.DDI.117': 'Distância total efectiva',
		'ISOBUS.DDI.118': 'Distância total ineficaz',
		'ISOBUS.DDI.119': 'Tempo total efectivo',
		'ISOBUS.DDI.12': 'Taxa de aplicação de contagem real por área',
		'ISOBUS.DDI.120': 'Tempo total ineficaz',
		'ISOBUS.DDI.121': 'Massa de densidade do produto por volume',
		'ISOBUS.DDI.122': 'Massa de densidade do produto per contagem',
		'ISOBUS.DDI.123': 'Volume de densidade do produto por contagem',
		'ISOBUS.DDI.124': 'Escala de válvulas auxiliares extender',
		'ISOBUS.DDI.125': 'Retracção da escala de válvulas auxiliares',
		'ISOBUS.DDI.126': 'Rampa de válvulas auxiliares estendida para cima',
		'ISOBUS.DDI.127': 'Rampa de válvulas auxiliares estendida para baixo',
		'ISOBUS.DDI.128': 'Válvula auxiliar de rampa de retracção',
		'ISOBUS.DDI.129': 'Válvula auxiliar de rampa de retracção',
		'ISOBUS.DDI.13': 'Contagem por defeito por área de taxa de aplicação',
		'ISOBUS.DDI.130': 'Limiar de flutuação de válvulas auxiliares',
		'ISOBUS.DDI.131': 'Extensão de progressividade da válvula auxiliar',
		'ISOBUS.DDI.132': 'Retração de progressividade da válvula auxiliar',
		'ISOBUS.DDI.133': 'Válvulas auxiliares portos invertidos',
		'ISOBUS.DDI.134': 'Offset do Elemento de Dispositivo X',
		'ISOBUS.DDI.135': 'Offset do Elemento de Dispositivo Y',
		'ISOBUS.DDI.136': 'Offset do Elemento de Dispositivo Z',
		'ISOBUS.DDI.137': 'Capacidade de volume do dispositivo',
		'ISOBUS.DDI.138': 'Capacidade de massa do dispositivo',
		'ISOBUS.DDI.139': 'Capacidade de contagem do dispositivo',
		'ISOBUS.DDI.14': 'Contagem mínima por área de taxa de aplicação',
		'ISOBUS.DDI.140': ' Ponto de ajuste da taxa de aplicação em porcentagem ',
		'ISOBUS.DDI.141': 'Estado real do trabalho',
		'ISOBUS.DDI.142': 'Ponto de partida física em tempo de latência',
		'ISOBUS.DDI.143': 'Valor físico actual em tempo de latência',
		'ISOBUS.DDI.144': 'Ângulo de guinada',
		'ISOBUS.DDI.145': 'Ângulo de rotação',
		'ISOBUS.DDI.146': 'Ângulo de inclinação',
		'ISOBUS.DDI.147': 'Contagem de registos',
		'ISOBUS.DDI.148': 'Consumo total de combustível',
		'ISOBUS.DDI.149': 'Consumo de combustível por tempo',
		'ISOBUS.DDI.15': 'Taxa de aplicação de contagem máxima por área',
		'ISOBUS.DDI.150': 'Consumo de combustível por área',
		'ISOBUS.DDI.151': 'Área por tempo de capacidade',
		'ISOBUS.DDI.153': 'Diferença Normalizada Índice Vegetativo (NDVI) Real ',
		'ISOBUS.DDI.154': 'Comprimento do objecto físico',
		'ISOBUS.DDI.155': 'Largura do objecto físico',
		'ISOBUS.DDI.156': 'Altura do objecto físico',
		'ISOBUS.DDI.157': 'Tipo de conector',
		'ISOBUS.DDI.158': 'Estado de controlo de prescrição',
		'ISOBUS.DDI.159': 'Número de sub-unidades por secção',
		'ISOBUS.DDI.16': 'Ponto de ajuste da taxa de aplicação de espaçamento de ',
		'ISOBUS.DDI.160': 'Secção estado de controlo',
		'ISOBUS.DDI.161': 'Estado de Trabalho Condensado Actual (1-16)',
		'ISOBUS.DDI.162': 'Estado de Trabalho Condensado Actual (17-32)',
		'ISOBUS.DDI.163': 'Estado de Trabalho Condensado Actual (33-48)',
		'ISOBUS.DDI.164': 'Estado de Trabalho Condensado Actual (49-64)',
		'ISOBUS.DDI.165': 'Estado de Trabalho Condensado Actual (65-80)',
		'ISOBUS.DDI.166': 'Estado de Trabalho Condensado Actual (81-96)',
		'ISOBUS.DDI.167': 'Estado de Trabalho Condensado Actual (97-112)',
		'ISOBUS.DDI.168': 'Estado de Trabalho Condensado Actual (113-128)',
		'ISOBUS.DDI.169': 'Estado de Trabalho Condensado Actual (129-144)',
		'ISOBUS.DDI.17': 'Taxa de aplicação do espaçamento real',
		'ISOBUS.DDI.170': 'Estado de Trabalho Condensado Actual (145-160)',
		'ISOBUS.DDI.171': 'Estado de Trabalho Condensado Actual (161-176)',
		'ISOBUS.DDI.172': 'Estado de Trabalho Condensado Actual (177-192)',
		'ISOBUS.DDI.173': 'Estado de Trabalho Condensado Actual (193-208)',
		'ISOBUS.DDI.174': 'Estado de Trabalho Condensado Actual (209-224)',
		'ISOBUS.DDI.175': 'Estado de Trabalho Condensado Actual (225-240)',
		'ISOBUS.DDI.176': 'Estado de Trabalho Condensado Actual (241-256)',
		'ISOBUS.DDI.177': 'Comprimento real de corte',
		'ISOBUS.DDI.178': 'Tipo de elemento instância',
		'ISOBUS.DDI.179': 'Prática cultural real',
		'ISOBUS.DDI.18': 'Taxa de aplicação do espaçamento por defeito',
		'ISOBUS.DDI.180': 'Ponto de referência do dispositivo (DRP) à distância ao solo',
		'ISOBUS.DDI.181': 'Massa seca por área de rendimento',
		'ISOBUS.DDI.182': 'Massa seca por tempo de rendimento',
		'ISOBUS.DDI.183': 'Rendimento total da massa seca',
		'ISOBUS.DDI.184': 'Rendimento total da massa seca',
		'ISOBUS.DDI.185': 'Rendimento de massa de algodão em caroço por área',
		'ISOBUS.DDI.186': 'Rendimento de massa de algodão fiapo por área',
		'ISOBUS.DDI.187': 'Massa de algodão em caroço por tempo de rendimento',
		'ISOBUS.DDI.188': 'Massa de algodão em fiapos por tempo de rendimento',
		'ISOBUS.DDI.189': 'Rendimento total massa de algodão em caroço',
		'ISOBUS.DDI.19': 'Taxa de aplicação do espaçamento mínimo',
		'ISOBUS.DDI.190': 'Rendimento total de massa de algodão fiapo',
		'ISOBUS.DDI.191': 'Percentagem de participação dos cotonetes',
		'ISOBUS.DDI.192': 'Temperatura ambiente',
		'ISOBUS.DDI.193': 'Ponto de ajuste da pressão do produto',
		'ISOBUS.DDI.194': 'Pressão real do produto',
		'ISOBUS.DDI.195': 'Pressão mínima do produto',
		'ISOBUS.DDI.196': 'Pressão máxima do produto',
		'ISOBUS.DDI.197': 'Ponto de ajuste da pressão de saída da bomba',
		'ISOBUS.DDI.198': 'Pressão real de saída da bomba',
		'ISOBUS.DDI.199': 'Pressão mínima de saída da bomba',
		'ISOBUS.DDI.2': 'Volume real por área de taxa de aplicação',
		'ISOBUS.DDI.20': 'Taxa máxima de aplicação do espaçamento',
		'ISOBUS.DDI.200': 'Pressão máxima de saída da bomba',
		'ISOBUS.DDI.201': 'Ponto de ajuste da pressão de saída do tanque',
		'ISOBUS.DDI.202': 'Pressão real de agitação do tanque',
		'ISOBUS.DDI.203': 'Pressão mínima de agitação do tanque',
		'ISOBUS.DDI.204': 'Pressão máxima de agitação do tanque',
		'ISOBUS.DDI.205': 'SC Ligar o tempo',
		'ISOBUS.DDI.206': 'SC Tempo de desligamento',
		'ISOBUS.DDI.207': 'Velocidade do vento',
		'ISOBUS.DDI.208': 'Direcção do vento',
		'ISOBUS.DDI.209': 'Humidade relativa',
		'ISOBUS.DDI.21': 'Ponto de ajuste da taxa de aplicação de volume por volume',
		'ISOBUS.DDI.210': 'Condições do céu',
		'ISOBUS.DDI.211': 'Últimos flocos de fardos',
		'ISOBUS.DDI.212': 'Humidade média do último fardo',
		'ISOBUS.DDI.213': 'Últimos AVCs médios por floco',
		'ISOBUS.DDI.214': 'Contagem de fardos total',
		'ISOBUS.DDI.215': 'Horas de trabalho total',
		'ISOBUS.DDI.216': 'Pressão hidráulica real do fardo',
		'ISOBUS.DDI.217': 'Último fardo da pressão hidráulica média',
		'ISOBUS.DDI.218': 'Ponto de ajuste de carga do êmbolo de compressão do fardo',
		'ISOBUS.DDI.219': 'Carga real do êmbolo de compressão do fardo',
		'ISOBUS.DDI.22': 'Volume real por volume da taxa de aplicação',
		'ISOBUS.DDI.220': 'Último fardo de compressão média do fardo de carga do êmbolo',
		'ISOBUS.DDI.221': 'Último fardo aplicado com conservante',
		'ISOBUS.DDI.222': 'Número da última etiqueta do fardo',
		'ISOBUS.DDI.223': 'Última missa de fardo',
		'ISOBUS.DDI.224': 'Delta T',
		'ISOBUS.DDI.225': 'Ponto de ajuste do comprimento de trabalho ',
		'ISOBUS.DDI.226': 'Duração real do trabalho',
		'ISOBUS.DDI.227': 'Duração mínima de trabalho',
		'ISOBUS.DDI.228': 'Duração máxima de trabalho',
		'ISOBUS.DDI.229': 'Peso líquido real',
		'ISOBUS.DDI.23': 'Volume predefinido por volume da taxa de aplicação',
		'ISOBUS.DDI.230': 'Estado de peso líquido',
		'ISOBUS.DDI.231': ' Ponto de ajuste do peso líquido ',
		'ISOBUS.DDI.232': 'Peso bruto real',
		'ISOBUS.DDI.233': 'Estado de peso bruto',
		'ISOBUS.DDI.234': 'Peso bruto mínimo',
		'ISOBUS.DDI.235': 'Peso bruto máximo',
		'ISOBUS.DDI.236': 'Tempo total de engajamento do debulhador',
		'ISOBUS.DDI.237': 'Situação real da altura de trabalho do cabeçalho',
		'ISOBUS.DDI.238': 'Estado real da velocidade de rotação do cabeçalho',
		'ISOBUS.DDI.239': 'Estado de rendimento',
		'ISOBUS.DDI.24': 'Volume mínimo por volume da taxa de aplicação',
		'ISOBUS.DDI.240': 'Estado real do sistema de (des)carregamento',
		'ISOBUS.DDI.241': 'Temperatura de cultivo',
		'ISOBUS.DDI.242': 'Ponto de ajuste da folga da peneira',
		'ISOBUS.DDI.243': 'Folga efectiva do crivo',
		'ISOBUS.DDI.244': 'Folga mínima do crivo',
		'ISOBUS.DDI.245': 'Folga máxima do crivo',
		'ISOBUS.DDI.246': 'Ponto de ajuste da folga do chaffer',
		'ISOBUS.DDI.247': 'Autorização real do chaffer',
		'ISOBUS.DDI.248': 'Limpeza mínima do chaffer',
		'ISOBUS.DDI.249': 'Limpeza máxima do chaffer',
		'ISOBUS.DDI.25': 'Volume máximo por volume de taxa de aplicação',
		'ISOBUS.DDI.250': 'Ponto de regulação da folga côncava',
		'ISOBUS.DDI.251': 'Apuramento côncavo real',
		'ISOBUS.DDI.252': 'Desobstrução mínima côncava',
		'ISOBUS.DDI.253': 'Desobstrução máxima côncava',
		'ISOBUS.DDI.254': 'Ponto de regulação de separação da velocidade de rotação do ventilador',
		'ISOBUS.DDI.255': 'Velocidade real de rotação do ventilador de separação',
		'ISOBUS.DDI.256': 'Velocidade mínima de rotação do ventilador de separação',
		'ISOBUS.DDI.257': 'Velocidade máxima de rotação do ventilador de separação',
		'ISOBUS.DDI.258': 'Temperatura do óleo hidráulico',
		'ISOBUS.DDI.259': 'Atraso de rendimento tempo ignorado',
		'ISOBUS.DDI.26': ' Ponto de ajuste de taxa de aplicação de massa por massa',
		'ISOBUS.DDI.260': 'Ignorar o tempo de chumbo',
		'ISOBUS.DDI.261': 'Massa de rendimento médio por tempo',
		'ISOBUS.DDI.262': 'Humidade média das culturas',
		'ISOBUS.DDI.263': 'Massa de rendimento médio por área',
		'ISOBUS.DDI.264': 'Conector Pivot X-Offset',
		'ISOBUS.DDI.265': 'Área restante',
		'ISOBUS.DDI.266': 'Aplicação da massa total',
		'ISOBUS.DDI.267': 'Contagem total de aplicativos ',
		'ISOBUS.DDI.268': 'Rendimento total em volume total',
		'ISOBUS.DDI.269': 'Rendimento total en massa total',
		'ISOBUS.DDI.27': 'Massa real por taxa de aplicação em massa',
		'ISOBUS.DDI.270': 'Contagem do rendimento total ',
		'ISOBUS.DDI.271': 'Área total ',
		'ISOBUS.DDI.272': 'Distância total eficaz ',
		'ISOBUS.DDI.273': 'Distância total ineficaz',
		'ISOBUS.DDI.274': 'Tempo de vida total',
		'ISOBUS.DDI.275': 'Tempo total ineficaz',
		'ISOBUS.DDI.276': 'Consumo de combustível total',
		'ISOBUS.DDI.277': 'Consumo médio de combustível total',
		'ISOBUS.DDI.278': 'Consumo médio de combustível por área total',
		'ISOBUS.DDI.279': 'Rendimento total da massa seca total',
		'ISOBUS.DDI.28': 'Massa predefinida por taxa de aplicação em massa',
		'ISOBUS.DDI.280': 'Rendimento total de sementes de algodão total',
		'ISOBUS.DDI.281': 'Rendimento total do algodão de linho',
		'ISOBUS.DDI.282': 'Tempo total de compromisso total',
		'ISOBUS.DDI.283': 'Contagem total pré-cortada',
		'ISOBUS.DDI.284': 'Contagem total não cortada',
		'ISOBUS.DDI.285': 'Contagem total pré-cortada total',
		'ISOBUS.DDI.286': 'Contagem total não cortada total',
		'ISOBUS.DDI.287': 'Modo de prescrição do ponto de paragem',
		'ISOBUS.DDI.288': 'Modo de prescrição real',
		'ISOBUS.DDI.289': ' Ponto de Partida do Estado de Trabalho ',
		'ISOBUS.DDI.29': 'Massa Mínima por Taxa de Aplicação de Massa',
		'ISOBUS.DDI.290': 'Setpoint Condensado Estado de Trabalho (1-16)',
		'ISOBUS.DDI.291': 'Setpoint Condensado Estado de Trabalho (17-32)',
		'ISOBUS.DDI.292': 'Setpoint Condensado Estado de Trabalho (33-48)',
		'ISOBUS.DDI.293': 'Setpoint Condensed Work State (49-64)',
		'ISOBUS.DDI.294': 'Setpoint Condensed Work State (65-80)',
		'ISOBUS.DDI.295': 'Setpoint Condensed Work State (81-96)',
		'ISOBUS.DDI.296': 'Setpoint Condensado Estado de Trabalho (97-112)',
		'ISOBUS.DDI.297': 'Setpoint Condensado Estado de Trabalho (113-128)',
		'ISOBUS.DDI.298': 'Setpoint Condensed Work State (129-144)',
		'ISOBUS.DDI.299': 'Setpoint Condensed Work State (145-160)',
		'ISOBUS.DDI.3': 'Volume predefinido por área de taxa de aplicação',
		'ISOBUS.DDI.30': 'Taxa máxima de aplicação de massa por massa',
		'ISOBUS.DDI.300': 'Setpoint Condensado Estado de Trabalho (161-176)',
		'ISOBUS.DDI.301': 'Setpoint Condensed Work State (177-192)',
		'ISOBUS.DDI.302': 'Setpoint Condensed Work State (193-208)',
		'ISOBUS.DDI.303': 'Setpoint Condensed Work State (209-224)',
		'ISOBUS.DDI.304': 'Setpoint Condensed Work State (225-240)',
		'ISOBUS.DDI.305': 'Setpoint Condensed Work State (241-256)',
		'ISOBUS.DDI.306': 'Verdadeiro Ponto de Rotação X-Offset',
		'ISOBUS.DDI.307': 'Verdadeiro Ponto de Rotação Y-Offset',
		'ISOBUS.DDI.308': 'Percentagem real de aplicação',
		'ISOBUS.DDI.309': 'Percentagem mínima de aplicação',
		'ISOBUS.DDI.31': 'Ponto de ajuste do volume de taxa de aplicação em massa',
		'ISOBUS.DDI.310': 'Percentagem máxima de aplicação',
		'ISOBUS.DDI.311': 'Potencial de Rendimento Relativo',
		'ISOBUS.DDI.312': 'Potencial de rendimento relativo mínimo',
		'ISOBUS.DDI.313': 'Potencial de rendimento relativo máximo',
		'ISOBUS.DDI.314': 'Percentagem real de matéria seca do cultivo',
		'ISOBUS.DDI.315': 'Percentagem média de matéria seca das culturas',
		'ISOBUS.DDI.316': 'Consumo total efectivo de combustível',
		'ISOBUS.DDI.317': 'Consumo total de combustível ineficaz',
		'ISOBUS.DDI.318': 'Consumo total efectivo de fluido para escapamento de gasóleo',
		'ISOBUS.DDI.319': 'Consumo total ineficaz de fluido para escapamento de gasóleo',
		'ISOBUS.DDI.32': 'Volume real por taxa de aplicação em massa',
		'ISOBUS.DDI.320': 'Último peso carregado',
		'ISOBUS.DDI.321': 'Último peso descarregado',
		'ISOBUS.DDI.322': 'Número de Identificação de carga',
		'ISOBUS.DDI.323': 'Número de identificação de descarga',
		'ISOBUS.DDI.324': 'Tempo total de envolvimento do helicóptero',
		'ISOBUS.DDI.325': 'Volume total da aplicação total',
		'ISOBUS.DDI.326': 'Ponto de ajuste da velocidade do cabeçalho',
		'ISOBUS.DDI.327': 'Velocidade real do cabeçalho',
		'ISOBUS.DDI.328': 'Velocidade mínima do cabeçalho',
		'ISOBUS.DDI.329': 'Velocidade máxima do cabeçalho',
		'ISOBUS.DDI.33': 'Volume predefinido por taxa de aplicação em massa',
		'ISOBUS.DDI.330': 'Ponto de ajuste de velocidade do tambor de corte',
		'ISOBUS.DDI.331': 'Velocidade real do tambor de corte',
		'ISOBUS.DDI.332': 'Velocidade mínima do tambor de corte',
		'ISOBUS.DDI.333': 'Velocidade máxima do tambor de corte',
		'ISOBUS.DDI.334': 'Horas de funcionamento desde a última afiação',
		'ISOBUS.DDI.335': 'Horas da TDF frontal',
		'ISOBUS.DDI.336': 'Horas da TDF traseira',
		'ISOBUS.DDI.337': 'Total de horas de TDP frontal',
		'ISOBUS.DDI.338': 'Total de horas da TDP traseira',
		'ISOBUS.DDI.339': 'Tempo total efectivo de carregamento',
		'ISOBUS.DDI.34': 'Volume mínimo por taxa de aplicação em massa',
		'ISOBUS.DDI.340': 'Tempo de descarga total efectivo',
		'ISOBUS.DDI.341': 'Ponto de regulação de abertura do cracker de grão de cereal',
		'ISOBUS.DDI.342': 'Abertura real para o grão de cereal ',
		'ISOBUS.DDI.343': 'Abertura mínima para o cracker de grãos de cereais',
		'ISOBUS.DDI.344': 'Abertura máxima do cracker de grão de cereais',
		'ISOBUS.DDI.345': 'Ponto de ajuste da largura de faixa',
		'ISOBUS.DDI.346': 'Largura real da faixa',
		'ISOBUS.DDI.347': 'Largura mínima de balanço',
		'ISOBUS.DDI.348': 'Largura máxima da faixa',
		'ISOBUS.DDI.349': 'Redução da deriva dos bicos',
		'ISOBUS.DDI.35': 'Volume máximo por taxa de aplicação em massa',
		'ISOBUS.DDI.350': 'Função ou técnica de operação',
		'ISOBUS.DDI.351': 'Volume total da aplicação',
		'ISOBUS.DDI.352': 'Massa total da aplicação',
		'ISOBUS.DDI.353': 'Aplicação total de nitrogénio',
		'ISOBUS.DDI.354': 'Aplicação total do amónio',
		'ISOBUS.DDI.355': 'Aplicação total de fósforo',
		'ISOBUS.DDI.356': 'Aplicação total de potássio',
		'ISOBUS.DDI.357': 'Aplicação total da matéria seca',
		'ISOBUS.DDI.358': 'Massa média de tendimento seco por tempo',
		'ISOBUS.DDI.359': 'Massa média de rendimento seco por área',
		'ISOBUS.DDI.36': 'Volumen de consigna por tiempo da tasa de aplicación',
		'ISOBUS.DDI.360': 'Tamanho do último fardo',
		'ISOBUS.DDI.361': 'Densidade do último fardo',
		'ISOBUS.DDI.362': 'Comprimento total do fardo',
		'ISOBUS.DDI.363': 'Última massa seca de fardo',
		'ISOBUS.DDI.364': 'Tamanho real do floco',
		'ISOBUS.DDI.365': 'Ponto de regulação da pressão de descida da força',
		'ISOBUS.DDI.366': 'Pressão real da força descendente',
		'ISOBUS.DDI.367': 'Estado de Sobreposição da Secção Condensada (1-16)',
		'ISOBUS.DDI.368': 'Estado de Sobreposição da Secção Condensada (17-32)',
		'ISOBUS.DDI.369': 'Estado de Sobreposição da Secção Condensada (33-48)',
		'ISOBUS.DDI.37': 'Volume real por tempo da taxa de aplicação',
		'ISOBUS.DDI.370': 'Estado de Sobreposição da Secção Condensada (49-64)',
		'ISOBUS.DDI.371': 'Estado de Sobreposição da Secção Condensada (65-80)',
		'ISOBUS.DDI.372': 'Estado de Sobreposição da Secção Condensada (81-96)',
		'ISOBUS.DDI.373': 'Estado de Sobreposição da Secção Condensada (97-112)',
		'ISOBUS.DDI.374': 'Estado de Sobreposição da Secção Condensada (113-128)',
		'ISOBUS.DDI.375': 'Estado de Sobreposição da Secção Condensada (129-144)',
		'ISOBUS.DDI.376': 'Estado de Sobreposição da Secção Condensada (145-160)',
		'ISOBUS.DDI.377': 'Estado de Sobreposição da Secção Condensada (161-176)',
		'ISOBUS.DDI.378': 'Estado de Sobreposição da Secção Condensada (177-192)',
		'ISOBUS.DDI.379': 'Estado de Sobreposição da Secção Condensada (193-208)',
		'ISOBUS.DDI.38': 'Volume predefinido por tempo da taxa de aplicação',
		'ISOBUS.DDI.380': 'Estado de Sobreposição da Secção Condensada (209-224)',
		'ISOBUS.DDI.381': 'Estado de Sobreposição da Secção Condensada (225-240)',
		'ISOBUS.DDI.382': 'Estado de Sobreposição da Secção Condensada (241-256)',
		'ISOBUS.DDI.383': 'Direcção do vento aparente',
		'ISOBUS.DDI.384': 'Velocidade do vento aparente',
		'ISOBUS.DDI.385': 'Pressão atmosférica MSL',
		'ISOBUS.DDI.386': 'Pressão atmosférica real',
		'ISOBUS.DDI.387': 'Total de Revoluções em Revoluções Fracionárias',
		'ISOBUS.DDI.388': 'Total de Revoluções em Revoluções Completas',
		'ISOBUS.DDI.389': 'Revoluciones de consigna especificadas como recuento por tiempo',
		'ISOBUS.DDI.39': 'Volume mínimo por tempo da taxa de aplicação',
		'ISOBUS.DDI.390': 'Revoluções efectivas por tempo',
		'ISOBUS.DDI.391': 'Revoluções por omissão por tempo',
		'ISOBUS.DDI.392': 'Rotações mínimas por tempo',
		'ISOBUS.DDI.393': 'Máximo de rotações por tempo',
		'ISOBUS.DDI.394': 'Máximo de rotações por tempo',
		'ISOBUS.DDI.395': 'Conteúdo real do tanque de fluido para escapamento de gasóleo',
		'ISOBUS.DDI.396': 'Ponto de ajuste da Velocidade ',
		'ISOBUS.DDI.397': 'Velocidade real',
		'ISOBUS.DDI.398': 'Velocidade Mínima',
		'ISOBUS.DDI.399': 'Velocidade máxima',
		'ISOBUS.DDI.4': 'Volume mínimo por área da taxa de aplicação',
		'ISOBUS.DDI.40': 'Volume máximo por tempo da taxa de aplicação',
		'ISOBUS.DDI.400': 'Fonte de velocidade',
		'ISOBUS.DDI.401': 'Aplicação real de nitrogénio',
		'ISOBUS.DDI.402': 'Aplicação real do Amonio',
		'ISOBUS.DDI.403': 'Aplicação real de Fósforo',
		'ISOBUS.DDI.404': 'Aplicação real do Potássio',
		'ISOBUS.DDI.405': 'Aplicação real da matéria seca',
		'ISOBUS.DDI.406': 'Conteúdo real de proteínas',
		'ISOBUS.DDI.407': 'Teor médio de proteínas',
		'ISOBUS.DDI.408': 'Contaminação de culturas médias',
		'ISOBUS.DDI.409': 'Consumo total de fluido para escapamento de gasóleo',
		'ISOBUS.DDI.41': 'Ponto de ajuste da Massa de  por tempo Taxa de aplicação',
		'ISOBUS.DDI.410': 'Cons. de fluido para escapamento de diesel por tempo',
		'ISOBUS.DDI.411': 'Cons. de fluido para escapamento de gasóleo por área',
		'ISOBUS.DDI.412': 'Consumo de exaustão diesel total',
		'ISOBUS.DDI.413': 'Consumo médio do escapamento de gasóleo total',
		'ISOBUS.DDI.414': 'Consumo médio do escapamento de gasóleo por área',
		'ISOBUS.DDI.415': 'Percentagem real de cântico de sementes',
		'ISOBUS.DDI.416': 'Percentagem média de cântico de sementes',
		'ISOBUS.DDI.417': 'Percentagem real de saltos de sementes',
		'ISOBUS.DDI.418': 'Percentagem média de saltos de sementes',
		'ISOBUS.DDI.419': 'Percentagem real de semente múltipla',
		'ISOBUS.DDI.42': 'Massa real por tempo da Taxa de aplicação',
		'ISOBUS.DDI.420': 'Percentagem média de semente múltipla',
		'ISOBUS.DDI.421': 'Desvio real do espaçamento de sementes',
		'ISOBUS.DDI.422': 'Desvio do Espaçamento Médio de Sementes',
		'ISOBUS.DDI.423': 'Coeficiente real de variação da percentagem do espaçamento de sementes',
		'ISOBUS.DDI.424': 'Coeficiente Médio de Variação da Porcentagem de Espaçamento de Sementes',
		'ISOBUS.DDI.425': 'Desvio do Espaçamento Máximo Permitido de Sementes',
		'ISOBUS.DDI.426': 'Consigna de carga aerodinámica como fuerza',
		'ISOBUS.DDI.427': 'Carga aerodinámica real como fuerza',
		'ISOBUS.DDI.428': 'Massa total carregada',
		'ISOBUS.DDI.429': 'Massa total descarregada',
		'ISOBUS.DDI.43': 'Massa predefinida por tempo da taxa de aplicação',
		'ISOBUS.DDI.430': 'Massa total carregada total',
		'ISOBUS.DDI.431': 'Massa total descarregada total',
		'ISOBUS.DDI.432': 'Ponto de ajuste da taxa de aplicação de nitrogénio ',
		'ISOBUS.DDI.433': 'Taxa real de aplicação de nitrogénio',
		'ISOBUS.DDI.434': 'Taxa mínima de aplicação de nitrogénio',
		'ISOBUS.DDI.435': 'Taxa máxima de aplicação de nitrogénio',
		'ISOBUS.DDI.436': 'Ponto de ajuste da taxa de aplicação do  amónio',
		'ISOBUS.DDI.437': 'Taxa real de aplicação de amónio',
		'ISOBUS.DDI.438': 'Taxa mínima de aplicação de amónio',
		'ISOBUS.DDI.439': 'Taxa máxima de aplicação de amónio',
		'ISOBUS.DDI.44': 'Massa mínima por tempo de taxa de aplicação',
		'ISOBUS.DDI.440': ' Ponto de ajuste da taxa de aplicação de fósforo ',
		'ISOBUS.DDI.441': 'Taxa real de aplicação de fósforo',
		'ISOBUS.DDI.442': 'Taxa mínima de aplicação de fósforo',
		'ISOBUS.DDI.443': 'Taxa máxima de aplicação de fósforo',
		'ISOBUS.DDI.444': ' Ponto de ajuste da taxa de aplicação de potássio',
		'ISOBUS.DDI.445': 'Taxa real de aplicação de potássio',
		'ISOBUS.DDI.446': 'Taxa mínima de aplicação de potássio',
		'ISOBUS.DDI.447': 'Taxa máxima de aplicação de potássio',
		'ISOBUS.DDI.448': ' Ponto de ajuste da taxa de aplicação de matéria seca',
		'ISOBUS.DDI.449': 'Taxa real de aplicação de matéria seca',
		'ISOBUS.DDI.45': 'Taxa máxima de aplicação de massa por tempo',
		'ISOBUS.DDI.450': 'Taxa mínima de aplicação de matéria seca',
		'ISOBUS.DDI.451': 'Taxa máxima de aplicação de matéria seca',
		'ISOBUS.DDI.452': 'Volume total carregado',
		'ISOBUS.DDI.453': 'Volume total descarregado',
		'ISOBUS.DDI.454': 'Volume total carregado total',
		'ISOBUS.DDI.455': 'Volume total descarregado total',
		'ISOBUS.DDI.456': 'Último volume carregado',
		'ISOBUS.DDI.457': 'Último volume descarregado',
		'ISOBUS.DDI.458': 'Contagem total carregada',
		'ISOBUS.DDI.459': 'Contagem total descarregada',
		'ISOBUS.DDI.46': 'Contagem de pontos de ajuste por tempo taxa de aplicação',
		'ISOBUS.DDI.460': 'Contagem total carregada total',
		'ISOBUS.DDI.461': 'Roconto total de descarga total',
		'ISOBUS.DDI.462': 'Última contagem carregada',
		'ISOBUS.DDI.463': 'Última contagem descarregada',
		'ISOBUS.DDI.464': 'Contador de transporte',
		'ISOBUS.DDI.465': 'Balcão de transporte total',
		'ISOBUS.DDI.466': 'Ângulo de ligação relativo real',
		'ISOBUS.DDI.467': 'Percentagem real de conteúdo',
		'ISOBUS.DDI.468': 'Neve do solo/Condição congelada',
		'ISOBUS.DDI.469': 'Condicionamento estimado da água do solo',
		'ISOBUS.DDI.47': 'Contagem real por tempo Taxa de aplicação',
		'ISOBUS.DDI.470': 'Compactação do solo',
		'ISOBUS.DDI.472': 'Ponto de ajuste do Comprimento de corte',
		'ISOBUS.DDI.473': 'Comprimento mínimo de corte',
		'ISOBUS.DDI.474': 'Comprimento máximo de corte',
		'ISOBUS.DDI.475': 'Ponto de ajuste Pressão Hidráulica do Fardos',
		'ISOBUS.DDI.476': 'Pressão Hidráulica Mínima dos Fardos',
		'ISOBUS.DDI.477': 'Pressão Hidráulica Máxima dos Fardos',
		'ISOBUS.DDI.478': 'Tamanho do floco de referência',
		'ISOBUS.DDI.479': 'Tamanho mínimo dos flocos',
		'ISOBUS.DDI.48': 'Contagem por defeito por tempo de taxa de aplicação',
		'ISOBUS.DDI.480': 'Tamanho máximo dos flocos',
		'ISOBUS.DDI.481': 'Ponto de ajuste Número de sub-balas',
		'ISOBUS.DDI.482': 'Número do último fardo de sub-balos',
		'ISOBUS.DDI.483': 'Velocidad del motor de consigna',
		'ISOBUS.DDI.484': 'Velocidade real do motor',
		'ISOBUS.DDI.485': 'Velocidade mínima do motor',
		'ISOBUS.DDI.486': 'Velocidade máxima do motor',
		'ISOBUS.DDI.488': 'Nível Percentual do Tanque de Fluido de Exaustão Diesel',
		'ISOBUS.DDI.489': 'Conteúdo Máximo do Tanque de Fluido de Exaustão Diesel',
		'ISOBUS.DDI.49': 'Contagem mínima por tempo Taxa de aplicação',
		'ISOBUS.DDI.490': 'Conteúdo Máximo do Tanque de Combustível',
		'ISOBUS.DDI.491': 'Nível de percentagem de combustível',
		'ISOBUS.DDI.492': 'Total de horas de motor',
		'ISOBUS.DDI.493': 'Horas de motor total',
		'ISOBUS.DDI.494': 'Último ID do parceiro do evento (Byte 1-4)',
		'ISOBUS.DDI.495': 'ID do parceiro do último evento (Byte 5-8)',
		'ISOBUS.DDI.496': 'ID do parceiro do último evento (Byte 9-12)',
		'ISOBUS.DDI.497': 'ID do parceiro do último evento (Byte 13-16)',
		'ISOBUS.DDI.498': 'Tipo de ID do parceiro do último evento',
		'ISOBUS.DDI.499': 'Último evento ID do parceiro código de identificação do fabricante',
		'ISOBUS.DDI.5': 'Volume máximo por área Taxa de aplicação',
		'ISOBUS.DDI.50': 'Contagem máxima por tempo Taxa de aplicação',
		'ISOBUS.DDI.500': 'Último evento classe do dispositivo de ID do parceiro',
		'ISOBUS.DDI.501': 'Punto de ajuste del par motor',
		'ISOBUS.DDI.502': 'Torque real do motor',
		'ISOBUS.DDI.503': 'Torque mínimo do motor',
		'ISOBUS.DDI.504': 'Torque máximo do motor',
		'ISOBUS.DDI.505': 'Nível de Controlo do Eléctrico',
		'ISOBUS.DDI.506': ' Punto de ajuste do Nivel de control de carril ',
		'ISOBUS.DDI.507': 'Número Sequencial do Tramline',
		'ISOBUS.DDI.508': 'Identificação única da linha de referência de orientação A-B',
		'ISOBUS.DDI.509': 'Número efectivo da faixa',
		'ISOBUS.DDI.51': 'Punto de ajuste da profundidad de labranza ',
		'ISOBUS.DDI.510': 'Número da faixa à direita',
		'ISOBUS.DDI.511': 'Número da faixa à esquerda',
		'ISOBUS.DDI.512': 'Largura de faixa da linha de orientação',
		'ISOBUS.DDI.513': 'Desvio da linha de orientação',
		'ISOBUS.DDI.514': 'Qualidade GNSS',
		'ISOBUS.DDI.515': 'Estado de controlo do eléctrico',
		'ISOBUS.DDI.516': 'Taxa de sobredosagem do tramline',
		'ISOBUS.DDI.517': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (1-16)',
		'ISOBUS.DDI.518': 'Estado actual do trabalho condensado do Eléctrico (1-16)',
		'ISOBUS.DDI.519': 'Última contagem total do fardo',
		'ISOBUS.DDI.52': 'Profundidade real da lavoura',
		'ISOBUS.DDI.520': 'Altura real do dossel',
		'ISOBUS.DDI.521': 'Tipo de instalação GNSS',
		'ISOBUS.DDI.522': 'Contagem total de fardo de corda',
		'ISOBUS.DDI.523': 'Contagem total de fardos de malha',
		'ISOBUS.DDI.524': 'Contagem total de fardos de cordel ',
		'ISOBUS.DDI.525': 'Contagem total de fardos de malha ',
		'ISOBUS.DDI.526': 'Temperatura real do fluido de arrefecimento',
		'ISOBUS.DDI.528': 'Capacidade do último fardo',
		'ISOBUS.DDI.529': 'Punto de ajuste so ángulo de grupo de discos de labranza',
		'ISOBUS.DDI.53': 'Profundidade por defeito da lavoura',
		'ISOBUS.DDI.530': 'Ângulo real do grupo do disco de lavoura',
		'ISOBUS.DDI.531': 'Preservante aplicado real por massa de rendimento',
		'ISOBUS.DDI.532': 'Consigna de conservante aplicado por masa de rendimiento',
		'ISOBUS.DDI.533': 'Conservante aplicado por omissão por massa de rendimento',
		'ISOBUS.DDI.534': 'Conservante mínimo aplicado por massa de rendimento',
		'ISOBUS.DDI.535': 'Conservante máximo aplicado por massa de rendimento',
		'ISOBUS.DDI.536': 'Conservante total aplicado',
		'ISOBUS.DDI.537': 'Conservante aplicado total',
		'ISOBUS.DDI.538': 'Conservante aplicado médio por massa de rendimento',
		'ISOBUS.DDI.539': 'Volume real do tanque conservador',
		'ISOBUS.DDI.54': 'Profundidade mínima da lavoura',
		'ISOBUS.DDI.540': 'Nível do tanque conservador real',
		'ISOBUS.DDI.541': 'Velocidade real da TDF',
		'ISOBUS.DDI.542': 'Velocidad de punto de referencia de la TDF',
		'ISOBUS.DDI.543': 'Velocidade por defeito da TDF',
		'ISOBUS.DDI.544': 'Velocidade mínima da tomada de força',
		'ISOBUS.DDI.545': 'Velocidade máxima da TDF',
		'ISOBUS.DDI.546': 'Tempo total de compromisso de corte ',
		'ISOBUS.DDI.547': 'Ponto de ajuste Carga do êmbolo de compressão do fardo',
		'ISOBUS.DDI.548': 'Carga real do êmbolo de compressão do fardo',
		'ISOBUS.DDI.549': 'Último fardo carga média do êmbolo de compressão do fardos',
		'ISOBUS.DDI.55': 'Profundidade máxima da lavoura',
		'ISOBUS.DDI.550': 'Cobertura do solo',
		'ISOBUS.DDI.551': 'Torque real da tomada de força',
		'ISOBUS.DDI.552': 'Ponto de ajuste TDF Torque',
		'ISOBUS.DDI.553': 'Torque por defeito da TDF',
		'ISOBUS.DDI.554': 'Torque mínimo da tomada de força',
		'ISOBUS.DDI.555': 'Torque máximo da tomada de força',
		'ISOBUS.DDI.556': 'Condições meteorológicas actuais',
		'ISOBUS.DDI.557': 'Ponto de ajuste da corrente eléctrica',
		'ISOBUS.DDI.558': 'Corrente eléctrica real',
		'ISOBUS.DDI.559': 'Corrente eléctrica mínima',
		'ISOBUS.DDI.56': 'Corrente eléctrica mínima',
		'ISOBUS.DDI.560': 'Corrente eléctrica máxima',
		'ISOBUS.DDI.561': 'Corrente eléctrica por defeito',
		'ISOBUS.DDI.562': 'Voltaje de consigna',
		'ISOBUS.DDI.563': 'Tensão por defeito',
		'ISOBUS.DDI.564': 'Tensão real',
		'ISOBUS.DDI.565': 'Tensão mínima',
		'ISOBUS.DDI.566': 'Tensão máxima',
		'ISOBUS.DDI.567': 'Resistência eléctrica real',
		'ISOBUS.DDI.568': 'Ponto de ajuste da energia eléctrica',
		'ISOBUS.DDI.569': 'Energia eléctrica real',
		'ISOBUS.DDI.57': 'Profundidade real da sementeira',
		'ISOBUS.DDI.570': 'Energia eléctrica por defeito',
		'ISOBUS.DDI.571': 'Potência eléctrica máxima',
		'ISOBUS.DDI.572': 'Energia eléctrica mínima',
		'ISOBUS.DDI.573': 'Energia eléctrica total',
		'ISOBUS.DDI.574': 'Ponto de ajuste da taxa de aplicação de energia elétrica ',
		'ISOBUS.DDI.575': 'Energia eléctrica real por área da taxa de aplicação',
		'ISOBUS.DDI.576': 'Taxa máxima de aplicação de energia eléctrica por área',
		'ISOBUS.DDI.577': 'Taxa mínima de aplicação de energia eléctrica por área',
		'ISOBUS.DDI.578': 'Temperatura de consigna',
		'ISOBUS.DDI.579': 'Temperatura real',
		'ISOBUS.DDI.58': 'Profundidade de semeadura por defeito',
		'ISOBUS.DDI.580': 'Temperatura mínima',
		'ISOBUS.DDI.581': 'Temperatura máxima',
		'ISOBUS.DDI.582': 'Temperatura por defeito',
		'ISOBUS.DDI.583': 'Frecuencia de consigna',
		'ISOBUS.DDI.584': 'Frequência real',
		'ISOBUS.DDI.585': 'Frequência mínima',
		'ISOBUS.DDI.586': 'Frequência máxima',
		'ISOBUS.DDI.587': 'Pluviosidade anterior',
		'ISOBUS.DDI.588': 'Volumen de punto de referencia por área de tasa de aplicación',
		'ISOBUS.DDI.589': 'Volume real por área de taxa de aplicação',
		'ISOBUS.DDI.59': 'Profundidade mínima de sementeira',
		'ISOBUS.DDI.590': 'Volume mínimo por área de taxa de aplicação',
		'ISOBUS.DDI.591': 'Volume máximo por área de taxa de aplicação',
		'ISOBUS.DDI.592': 'Volume predefinido por área de taxa de aplicação',
		'ISOBUS.DDI.593': 'Tipo de tracção',
		'ISOBUS.DDI.594': 'Tipo de direcção',
		'ISOBUS.DDI.595': 'Modo de máquina',
		'ISOBUS.DDI.596': 'Estado de cobertura da área de carga',
		'ISOBUS.DDI.597': 'Distância total',
		'ISOBUS.DDI.598': 'Distância total ao longo da vida',
		'ISOBUS.DDI.599': 'Campo à distância total',
		'ISOBUS.DDI.6': 'Tasa de aplicación de masa por área de consigna',
		'ISOBUS.DDI.60': 'Profundidade máxima de sementeira',
		'ISOBUS.DDI.600': 'Campo de distância total',
		'ISOBUS.DDI.601': 'Rua da Distância Total',
		'ISOBUS.DDI.602': 'Rua da distância total ',
		'ISOBUS.DDI.603': 'Estado actual do trabalho condensado do eléctrico (17-32)',
		'ISOBUS.DDI.604': 'Estado actual do trabalho condensado do eléctrico  (33-48)',
		'ISOBUS.DDI.605': 'Estado actual do trabalho condensado do eléctrico (49-64)',
		'ISOBUS.DDI.606': 'Estado actual do trabalho condensado do eléctrico  (65-80)',
		'ISOBUS.DDI.607': 'Estado actual do trabalho condensado do eléctrico (81-96)',
		'ISOBUS.DDI.608': 'Estado actual do trabalho condensado do eléctrico (97-112)',
		'ISOBUS.DDI.609': 'Estado actual do trabalho condensado do eléctrico (113-128)',
		'ISOBUS.DDI.61': 'Altura de trabalho do ponto de ajuste',
		'ISOBUS.DDI.610': 'Estado actual do trabalho condensado do eléctrico (129-144)',
		'ISOBUS.DDI.611': 'Estado actual do trabalho condensado do eléctrico (145-160)',
		'ISOBUS.DDI.612': 'Estado actual do trabalho condensado do eléctrico (161-176)',
		'ISOBUS.DDI.613': 'Estado actual do trabalho condensado do Eléctrico (177-192)',
		'ISOBUS.DDI.614': 'Estado actual do trabalho condensado do eléctrico (193-208)',
		'ISOBUS.DDI.615': 'Estado actual do trabalho condensado do eléctrico (209-224)',
		'ISOBUS.DDI.616': 'Estado actual do trabalho condensado do eléctrico (225-240)',
		'ISOBUS.DDI.617': 'Estado actual do trabalho condensado do eléctrico (241-256)',
		'ISOBUS.DDI.618': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (17-32)',
		'ISOBUS.DDI.619': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (33-48)',
		'ISOBUS.DDI.62': 'Altura real de trabalho',
		'ISOBUS.DDI.620': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (49-64)',
		'ISOBUS.DDI.621': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (65-80)',
		'ISOBUS.DDI.622': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (81-96)',
		'ISOBUS.DDI.623': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (97-112)',
		'ISOBUS.DDI.624': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (113-128)',
		'ISOBUS.DDI.625': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (129-144)',
		'ISOBUS.DDI.626': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (145-160)',
		'ISOBUS.DDI.627': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (161-176)',
		'ISOBUS.DDI.628': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (177-192)',
		'ISOBUS.DDI.629': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (193-208)',
		'ISOBUS.DDI.63': 'Altura de trabalho por defeito',
		'ISOBUS.DDI.630': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (209-224)',
		'ISOBUS.DDI.631': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (225-240)',
		'ISOBUS.DDI.632': 'Ponto de ajuste Estado de Trabalho Condensado do Eléctrico (241-256)',
		'ISOBUS.DDI.634': 'Volume real por distância de taxa de aplicação',
		'ISOBUS.DDI.635': 'Volume por defeito por distância de taxa de aplicação',
		'ISOBUS.DDI.636': 'Volume mínimo por distância de taxa de aplicação',
		'ISOBUS.DDI.637': 'Volume máximo por distância de taxa de aplicação',
		'ISOBUS.DDI.638': 'Ponto de regulação da pressão dos pneus',
		'ISOBUS.DDI.639': 'Pressão real dos pneus',
		'ISOBUS.DDI.64': 'Altura mínima de trabalho',
		'ISOBUS.DDI.640': 'Pressão dos pneus por defeito',
		'ISOBUS.DDI.641': 'Pressão mínima dos pneus',
		'ISOBUS.DDI.642': 'Pressão máxima dos pneus',
		'ISOBUS.DDI.643': 'Temperatura real dos pneus',
		'ISOBUS.DDI.65': 'Altura máxima de trabalho',
		'ISOBUS.DDI.66': 'Ponto de ajuste da largura de trabalho ',
		'ISOBUS.DDI.67': 'Largura real de trabalho',
		'ISOBUS.DDI.68': 'Largura de trabalho por defeito',
		'ISOBUS.DDI.69': 'Largura mínima de trabalho',
		'ISOBUS.DDI.7': 'Massa real por taxa de aplicação de área',
		'ISOBUS.DDI.70': 'Largura máxima de trabalho',
		'ISOBUS.DDI.71': 'Ponto de ajuste do conteúdo do volume ',
		'ISOBUS.DDI.72': 'Conteúdo real do volume',
		'ISOBUS.DDI.73': 'Conteúdo máximo de volume',
		'ISOBUS.DDI.74': 'Ponto de ajuste do conteúdo de massa ',
		'ISOBUS.DDI.75': 'Conteúdo de massa actual',
		'ISOBUS.DDI.76': 'Conteúdo máximo de massa',
		'ISOBUS.DDI.77': 'Pontos de ajuste do conteúdo da contagem',
		'ISOBUS.DDI.78': 'Conteúdo real da contagem',
		'ISOBUS.DDI.79': 'Conteúdo máximo de contagem',
		'ISOBUS.DDI.8': 'Massa padrão por taxa de aplicação de área',
		'ISOBUS.DDI.80': 'Volume total da aplicação',
		'ISOBUS.DDI.81': 'Massa total da aplicação',
		'ISOBUS.DDI.82': 'Contagem total da aplicação',
		'ISOBUS.DDI.83': 'Volume por área de rendimento',
		'ISOBUS.DDI.84': 'Massa por área de rendimento',
		'ISOBUS.DDI.85': 'Contagem por área de rendimento',
		'ISOBUS.DDI.86': 'Volume por rendimento de tempo',
		'ISOBUS.DDI.87': 'Massa por tempo rendimento',
		'ISOBUS.DDI.88': 'Contagem por rendimento temporal',
		'ISOBUS.DDI.89': 'Rendimento volume total',
		'ISOBUS.DDI.9': 'Taxa mínima de aplicação de massa por área',
		'ISOBUS.DDI.90': 'Massa total de rendimento',
		'ISOBUS.DDI.91': 'Rendimento contagem total',
		'ISOBUS.DDI.92': 'Volume por área de perda de colheitas',
		'ISOBUS.DDI.93': 'Perda de massa por área de cultura',
		'ISOBUS.DDI.94': 'Contagem por área de perda de colheitas',
		'ISOBUS.DDI.95': 'Volume por perda de cultivo de tempo',
		'ISOBUS.DDI.96': 'Perda de massa por tempo de cultura',
		'ISOBUS.DDI.97': 'Contagem por perda de cultivo de tempo',
		'ISOBUS.DDI.98': 'Percentagem de perda de colheitas',
		'ISOBUS.DDI.99': 'Humidade das culturas',
		'ISOBUS.DEVICE_CLASS.0': 'NonSpec',
		'ISOBUS.DEVICE_CLASS.1': 'Tractor',
		'ISOBUS.DEVICE_CLASS.10': 'Irrigação',
		'ISOBUS.DEVICE_CLASS.11': 'Transporte/Reboque',
		'ISOBUS.DEVICE_CLASS.12': 'Exploração de quintas',
		'ISOBUS.DEVICE_CLASS.13': 'Dispositivos Auxiliares Motorizados',
		'ISOBUS.DEVICE_CLASS.14': 'Culturas Especiais',
		'ISOBUS.DEVICE_CLASS.15': 'Trabalho da Terra',
		'ISOBUS.DEVICE_CLASS.16': 'Skidder',
		'ISOBUS.DEVICE_CLASS.17': 'Sistemas de sensores',
		'ISOBUS.DEVICE_CLASS.18': '-',
		'ISOBUS.DEVICE_CLASS.19': 'Colhedores de madeira',
		'ISOBUS.DEVICE_CLASS.2': 'Lavoura',
		'ISOBUS.DEVICE_CLASS.20': 'Despachantes',
		'ISOBUS.DEVICE_CLASS.21': 'Carregadores de madeira',
		'ISOBUS.DEVICE_CLASS.22': 'Máquinas de processamento de madeira',
		'ISOBUS.DEVICE_CLASS.23': 'Trituradores',
		'ISOBUS.DEVICE_CLASS.24': 'Veículos utilitários',
		'ISOBUS.DEVICE_CLASS.25': 'Aplicadores de chorume/Manuros',
		'ISOBUS.DEVICE_CLASS.26': 'Alimentadores/Misturadores',
		'ISOBUS.DEVICE_CLASS.27': 'Capinadores',
		'ISOBUS.DEVICE_CLASS.3': 'Alojamento Secundário',
		'ISOBUS.DEVICE_CLASS.4': 'Plantadores/Semeedadores',
		'ISOBUS.DEVICE_CLASS.5': 'Fertilizadores',
		'ISOBUS.DEVICE_CLASS.6': 'Pulverizadores',
		'ISOBUS.DEVICE_CLASS.7': 'Colhedores',
		'ISOBUS.DEVICE_CLASS.8': 'Colhedores de Raiz',
		'ISOBUS.DEVICE_CLASS.9': 'Forragem',
		'JOB.ARCHIVE.QUESTION': 'Deseja realmente arquivar o trabalho selecionado?',
		'JOB.ARCHIVE.SUCCESS': 'A viagem foi arquivada.',
		'JOB.CAN_NOT_BE_DISPLAYED_COMPLETELY': 'O trabalho não pode ser exibido completamente. Qualquer informação acima pode estar desactualizada e vai ser recalculada.',
		'JOB.CURRENT_STATUS': 'Estado atual',
		'JOB.DELETE.QUESTION': 'Deseja realmente excluir a viagem selecionada?',
		'JOB.DELETE.SUCCESS': 'A viagem foi marcada para exclusão.',
		'JOB.DETAILS': 'Detalhes do trabalho',
		'JOB.DRIVER_IMPLEMENT': 'DRIVER_IMPLEMENT',
		'JOB.EDIT': 'Editar trabalho',
		'JOB.REGENERATE': 'Regenerar o trabalho',
		'JOB.REGENERATE.DRIVER': 'Recalcular dados do motorista',
		'JOB.REGENERATE.FIELDS': 'Actualização de dados de campo',
		'JOB.REGENERATE.IMPLEMENT': 'Recalcular dados das alfaias',
		'JOB.REGENERATE.INTRO': 'Se os dados de facturação de máquinas, alfaias ou condutores tiverem sido alterados, podem também ser actualizados.',
		'JOB.REGENERATE.LOCATIONS': 'Actualizar dados de localização',
		'JOB.REGENERATE.MACHINE': 'Recalcular dados da máquina',
		'JOB.REGENERATE.QUESTION': 'Que dados devem ser actualizados?',
		'JOB.REGENERATE.SUCCESS': 'A viagem foi recalculada',
		'JOB.SPLIT': 'Dividir viagem',
		'JOB.SPLIT.ADD_SPLIT_TIME': 'Adicionar tempo para divisão da viagem',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO': 'Para um ajuste preciso dos segundos, você pode utilizar as teclas de seta para operar os controles deslizantes.',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO2': 'Adicionar/remover tempo para dividir a viagem.',
		'JOB.SPLIT.NO_CHANGE': 'A viagem não foi alterada',
		'JOB.SPLIT.NO_SPLITS': 'Nenhum tempo para divisão foi selecionado',
		'JOB.UPDATE': 'Atualizar trabalhos',
		'JOB.WAITING_TIME_UNTIL_READY': 'Dependendo do estado actual, pode demorar alguns minutos até que o trabalho possa ser mostrado completamente.',
		'JOBS': 'Trabalhos',
		'JOBS.ALL': 'Todos os trabalhos',
		'JOBS.ARCHIVE.PARTIAL': 'Alguns trabalhos são arquivados.',
		'JOBS.ARCHIVE.QUESTION': 'Quer mesmo arquivar os trabalhos seleccionados?',
		'JOBS.ARCHIVE.SUCCESS': 'Vão ser arquivados empregos',
		'JOBS.CREATE_TASK': 'Criar trabalho',
		'JOBS.DELETE.QUESTION': 'Pretende realmente eliminar as tarefas seleccionadas? Todos os dados das tarefas serão removidos de forma irreversível.',
		'JOBS.DELETE.SUCCESS': 'Os trabalhos vão ser eliminados',
		'JOBS.DELETED.FAILURE': 'Alguns dos trabalhos não puderam ser eliminados.',
		'JOBS.EDIT': 'Editar empregos',
		'JOBS.EDIT.SUCCESS': 'Os trabalhos vão ser editados',
		'JOBS.IN_TASK': 'Empregos em tarefas',
		'JOBS.MERGE.SUCCESS': 'As viagens foram mescladas',
		'JOBS.MERGING': 'Fusão de viagens',
		'JOBS.NO': 'Sem empregos',
		'JOBS.NOT_SELECTED': 'Seleccionar trabalhos da lista acima para os adicionar à tarefa.',
		'JOBS.REGENERATE': 'Regenerar empregos',
		'JOBS.REGENERATE.SUCCESS': 'Vão ser regenerados empregos',
		'JOBS.SELECTED': 'Trabalhos seleccionados',
		'JOBS.TASK_CREATED': 'Atividade criada com sucesso!',
		'JOBS.UPDATE.SUCCESS': 'Os empregos serão atualizados',
		'JOBS.WITHOUT_TASK': 'Empregos sem tarefa',
		'JOBS.WITH_TASK': 'Empregos na tarefa',
		'KILOMETERS': 'Quilómetros',
		'LANGUAGE': 'Língua',
		'LANGUAGE.ADD': 'Adicionar idioma',
		'LANGUAGE.CODE': 'Código do idioma',
		'LANGUAGE.DEFAULT': 'Idioma default',
		'LASTNAME': 'Sobrenome',
		'LAST_ONLINE': 'Última vez em linha',
		'LAST_UPDATED': 'Última edição',
		'LATITUDE': 'Latitude',
		'LOAD.MORE': 'Carregar mais',
		'LOADS': 'Loads',
		'LOCATION': 'Localizações',
		'LOCATION.ADD': 'Adicionar localização',
		'LOCATION.ADD.SUCCESS': 'Localização acrescentada com sucesso',
		'LOCATION.DEACTIVATE.QUESTION': 'Você realmente deseja desativar o local?',
		'LOCATION.DEACTIVATE.SUCCESS': 'Localização desativada com sucesso',
		'LOCATION.DELETE.QUESTION': 'Deseja realmente excluir o local?',
		'LOCATION.DELETE.SUCCESS': 'Local excluído com sucesso',
		'LOCATION.DETAILS': 'Location details',
		'LOCATION.DRAW.START': 'Marque a localização no mapa!',
		'LOCATION.EDIT.SUCCESS': 'Localização editada com sucesso',
		'LOCATIONS': 'Gestão de locais',
		'LOCATIONS.ALL': 'Todos os locais',
		'LOCATIONS.DEACTIVATE.FAILURE': 'Alguns dos locais não puderam ser desativados.',
		'LOCATIONS.DEACTIVATE.QUESTION': 'Você realmente deseja desativar os locais?',
		'LOCATIONS.DEACTIVATE.SUCCESS': 'Locais desativados com sucesso',
		'LOCATIONS.DELETE.FAILURE': 'Alguns dos locais não puderam ser apagados.',
		'LOCATIONS.DELETE.QUESTION': 'Você realmente deseja excluir os locais selecionados?',
		'LOCATIONS.DELETE.SUCCESS': 'Local removido.',
		'LOCATIONS.NO': 'Sem localizações',
		'LOCATIONS.NOT_SELECTED': 'Nenhum local seleccionado',
		'LOCATIONS.REACTIVATE.FAILURE': 'Alguns dos locais não puderam ser reativados.',
		'LOCATIONS.REACTIVATE.QUESTION': 'Deseja mesmo reativar os locais selecionados?',
		'LOCATIONS.REACTIVATE.SUCCESS': 'Locais reativados com sucesso',
		'LOCATIONS.SELECTED': 'Localizações seleccionadas',
		'LOG': 'Registo de mensagens',
		'LOGIN': 'Entrar',
		'LOGIN.NOT_UNLOCKED_YET': 'Ainda não ativou a conta?',
		'LOGIN.NO_ACCOUNT_YET': 'Não tem uma conta?',
		'LOGIN.PASSWORD_FORGOTTEN': 'Esqueceu a senha?',
		'LOGIN.REGISTER': 'Registrar',
		'LOGIN.REMEMBER_PASSWORD': 'Lembrar senha',
		'LOGIN.UNLOCK': 'Ativar a conta',
		'LOG_OUT': 'Sair',
		'LONGITUDE': 'Longitude',
		'LOST_PASSWORD.CHANGE_PASSWORD': 'Alterar senha',
		'LOST_PASSWORD.ENTER_ACTIVATION': 'Introduza o código de activação que recebeu por correio electrónico.',
		'LOST_PASSWORD.ENTER_EMAIL_HERE': 'Por favor, informe o seu endereço de e-mail.',
		'LOST_PASSWORD.ENTER_VALID_EMAIL': 'Por favor, insira um endereço de e-mail vAlido.',
		'MAC': 'Endereço MAC',
		'MACHINE': 'Veículo',
		'MACHINE.ADD': 'Adicionar veículo',
		'MACHINE.ADD.SUCCESS': 'Veículo adicionado com sucesso',
		'MACHINE.DELETE.QUESTION': 'Deseja realmente remover o veículo?',
		'MACHINE.DELETE.SUCCESS': 'Veículo removido com sucesso',
		'MACHINE.DETAILS': 'Detalhes do veículo',
		'MACHINE.EDIT': 'Editar veículo',
		'MACHINE.EDIT.SUCCESS': 'Veículo editado com sucesso',
		'MACHINE.INTERVAL.ADD': 'Adicionar intervalo de máquina',
		'MACHINE.LIVE_STATUS': 'Estado em directo da máquina',
		'MACHINE.NO': 'Nenhuma máquina',
		'MACHINE.RELOAD_POSITIONS': 'Atualizar posições das máquinas',
		'MACHINE.STATUS': 'Estado do veículo',
		'MACHINES': 'Veículos',
		'MACHINES.ALL': 'Todas as máquinas',
		'MACHINES.DEACTIVATE.FAILURE': 'Algumas das máquinas não puderam ser desativadas.',
		'MACHINES.DEACTIVATE.QUESTION': 'Deseja realmente desativar as máquinas selecionadas?',
		'MACHINES.DEACTIVATE.SUCCESS': 'Máquinas desativadas com sucesso',
		'MACHINES.DELETE.FAILURE': 'Algumas das máquinas não puderam ser excluídas',
		'MACHINES.DELETE.QUESTION': 'Você realmente deseja excluir as máquinas selecionadas?',
		'MACHINES.DELETE.SUCCESS': 'Máquinas excluídas com sucesso',
		'MACHINES.MANAGEMENT': 'Gestão de veículos',
		'MACHINES.NO': 'Nenhuma máquina',
		'MACHINES.NOT_SELECTED': 'Nenhuma máquina selecionada',
		'MACHINES.NO_LICENSE.WARNING': 'A máquina não tem licença anexa. Sem uma licença não serão registados quaisquer dados.',
		'MACHINES.REACTIVATE.FAILURE': 'Não foi possível reativar algumas máquinas.',
		'MACHINES.REACTIVATE.QUESTION': 'Realmente deseja reativar as máquinas selecionadas?',
		'MACHINES.REACTIVATE.SUCCESS': 'Máquinas reativadas com sucesso',
		'MACHINES.SELECTED': 'Máquinas selecionadas',
		'MACHINE_COMBINATION': 'Machine combination',
		'MACHINE_IMPLEMENT': 'Máquina/Alfaia',
		'MAC_DEVICES': 'Adaptadores ligados ao veículo',
		'MAINTENANCE': 'Manutenção',
		'MAINTENANCE.AMOUNT': 'Manutenção total',
		'MAINTENANCE.PERIOD': 'Período de manutenção',
		'MAKE': 'Marca',
		'MANURE': 'Esterco',
		'MANURE.TYPE': 'Tipo de esterco',
		'MAP': 'Mapa',
		'MAP.SECTION': 'Seção do mapa',
		'MAP.SECTION.CHANGE': 'Alterar a seção do mapa',
		'MARKER.ADD': 'Adicionar novo marcador',
		'MARKER.EDIT.BORDERS': 'Editar fronteiras',
		'MARKER.ENTRANCE': 'Entrada',
		'MARKER.EXIT': 'Saída',
		'MARKER.INFO': 'Informação',
		'MARKER.WARN': 'Aviso',
		'MAX': 'Máximo',
		'MAX_VALUE': 'Valor máximo',
		'MERGE': 'Mesclar viagens',
		'MESSAGES.NO': 'Nenhuma mensagem',
		'MILEAGE': 'Quilometragem',
		'MILEAGE.INVALID': 'Quilometragem inválida',
		'MIN': 'Mínimo',
		'MIN_VALUE': 'Valor mínimo',
		'MOBILE': 'Celular',
		'MODE.SWITCH': 'Trocar modo',
		'MODEL': 'Modelo',
		'MYPROFILE': 'Meu perfil',
		'MYPROFILE.BASIC_DATA': 'Dados básicos',
		'MYPROFILE.BASIC_DATA.EDIT.SUCCESS': 'Os seus dados básicos foram alterados com sucesso',
		'NAME': 'Nome',
		'NAV.ACTIVITIES': 'Atividades',
		'NAV.ADMIN': 'Administração',
		'NAV.ADMIN.DASHBOARD': 'Painel',
		'NAV.ADMIN.INFO_VIEW': 'Admin Info',
		'NAV.ADMIN.JOB_IMPORT_VIEW': 'Job import',
		'NAV.ADMIN.JOB_VIEW': 'Visualização do trabalho',
		'NAV.ADMIN.USERS': 'Gerenciamento de usuários',
		'NAV.CUSTOMERS': 'Clientes',
		'NAV.DASHBOARD': 'Visão geral',
		'NAV.DATA_PREPARATION': 'Preparação dos dados',
		'NAV.EMPLOYEES': 'Funcionários',
		'NAV.ENTERPRISE': 'Empresa',
		'NAV.FIELDS': 'Campos armazenados com sucesso.',
		'NAV.FILE_TRANSFER': 'Dados ISO',
		'NAV.HARDWARE': 'Hardware',
		'NAV.HARDWARE_SETUP': 'Configuração do hardware',
		'NAV.IMPLEMENTS': 'Alfaias',
		'NAV.LOCATIONS': 'Locais',
		'NAV.MACHINES': 'Veículos',
		'NAV.MY_SECTION': 'Minha Area',
		'NAV.PATH_PLANNINGS': 'Path planning',
		'NAV.RETAILER': 'Varejista',
		'NAV.SETTINGS': 'Configurações',
		'NAV.SETTINGS.ADAPTER': 'Adaptador',
		'NAV.SETTINGS.GENERAL': 'Empresa',
		'NAV.SETTINGS.PARTNER': 'Parceiro',
		'NAV.STATISTIC': 'Estatística',
		'NAV.TECH': 'Técnico',
		'NAV.TRANSLATION.EDIT': 'Editar tradução',
		'NAV.TRANSLATION_MANAGEMENT': 'Gerenciador de tradução',
		'NETWORK.ACCESS_TECHNOLOGY': 'Tecnologia de acesso',
		'NETWORK.OPERATOR': 'Operator',
		'NEXT': 'Próximo',
		'NO': 'Não',
		'NONE': 'Nenhum',
		'NOTICE': 'Aviso',
		'NON_PRODUCTIVE_TIME': 'Tempo não produtivo',
		'NON_PRODUCTIVE_TIMES': 'Tempos não produtivos',
		'NON_PRODUCTIVE_TIMES.SEPARATOR': 'Separator for non productive time computation',
		'NOT_READ': 'Não foi possível ler.',
		'NO_DATA': 'Nenhuma informação',
		'ONLY_ON': 'Apenas em',
		'OPACITY': 'Opacidade',
		'OPERATING_HOURS': 'Tempo de operação',
		'OPERATING_HOURS.INVALID': 'Tempo de operação inválido',
		'OPERATION': 'Operação',
		'OPERATION.NOT_SELECTED': 'Por favor, selecione uma medida.',
		'OPERATION.SELECT': 'Selecione operação',
		'OPERATIONS': 'Operações',
		'OPERATIONS.ARRIVAL': 'Chegada',
		'OPERATIONS.CUSTOMER': 'Operação para consumidor',
		'OPERATIONS.FIELD': 'Operação no campo',
		'OPERATIONS.FIELDS': 'Operações nos campos',
		'OPERATIONS.FIELD_TIME': 'Tempo em campo',
		'OPERATIONS.GEOMETRY': 'Geometria',
		'OPERATIONS.LOCATION': 'Operações na localização',
		'OPERATIONS.LOCATIONS': 'Operações nas localizações',
		'OPERATIONS.NO': 'Nenhuma operação',
		'OPERATIONS.PREPARATION': 'Preparação',
		'OVERRIDE.NO': 'Nenhuma anulação',
		'PAGE': 'Page',
		'PAGE.OF': 'of',
		'PAGINATION.PER_PAGE': 'Por página',
		'PAGINATION.TOTAL': 'total',
		'PAGINATOR.FIRST_PAGE': 'Primeira página',
		'PAGINATOR.ITEMS_PER_PAGE': 'Itens por página',
		'PAGINATOR.LAST_PAGE': 'Última página',
		'PAGINATOR.NEXT_PAGE': 'Página seguinte',
		'PAGINATOR.OF': 'de',
		'PAGINATOR.PREVIOUS_PAGE': 'Página anterior',
		'PARTNER_CONNECTION': 'Conexão com parceiro',
		'PARTNER_CONNECTION.DOES_NOT_EXPIRE': 'Não expira',
		'PARTNER_CONNECTION.EXPIRES_ON': 'Expira em',
		'PASSWORD': 'Senha',
		'PASSWORD.CHANGE': 'Alterar senha',
		'PASSWORD.CHANGE.ACTIVATE': 'Senha atual',
		'PASSWORD.CHANGE.SUCCESS': 'A sua senha foi alterada com sucesso',
		'PASSWORD.CONFIRM': 'Confirmar nova senha',
		'PASSWORD.LENGTH.REQUIRED': 'A senha deve ter pelo menos 6 caracteres.',
		'PASSWORD.NEW_PASSWORD': 'Nova senha',
		'PASSWORD.NO_MATCH': 'As senhas são diferentes',
		'PATH_PLANNING.ADD': 'Plan path',
		'PATH_PLANNING.ADD.SUCCESS': 'Planned path successfully added',
		'PATH_PLANNING.ANGLE': 'Angle',
		'PATH_PLANNING.ANGLE.LONGEST_SIDE': 'Longest side',
		'PATH_PLANNING.ANGLE.OPTIMAL': 'Optimal',
		'PATH_PLANNING.ANGLE.WORKING': 'Working angle',
		'PATH_PLANNING.AREA.COVERED': 'Covered area',
		'PATH_PLANNING.AREA.OVERLAP': 'Overlapped area',
		'PATH_PLANNING.AREA.UNCOVERED': 'Uncovered area',
		'PATH_PLANNING.DETAILS': 'Planned path',
		'PATH_PLANNING.GENERATE_PATH': 'Generate path',
		'PATH_PLANNING.GEOMETRY.CHANGED.QUESTION': 'The field boundary has been changed. Do you want to store the boundary as the current boundary of the field?',
		'PATH_PLANNING.NAME': 'Path planning name',
		'PATH_PLANNING.NAME.EXPLANATION': 'Give the path planning a name',
		'PATH_PLANNING.NOT_ENOUGH_DATA_EXPECTATION': 'Currently there is not enough data to compute the expected fuel consumption, CO2 consumption and cost',
		'PATH_PLANNING.SELECT.FIELD': 'Select the field you want the path to be planned for',
		'PATH_PLANNING.SEND_TO_MACHINE': 'Send to machine',
		'PATH_PLANNING.SETTINGS.CHANGED.QUESTION': 'The settings have been changed after generating the currently shown planned path and will not be reflected when saved. Do you want to continue?',
		'PATH_PLANNING.SUBDIVIDE': 'Subdivide field',
		'PATH_PLANNINGS.DEACTIVATE.FAILURE': 'Some of the planned paths could not be deactivated',
		'PATH_PLANNINGS.DEACTIVATE.QUESTION': 'Do you really want to deactivate the planned path?',
		'PATH_PLANNINGS.DEACTIVATE.SUCCESS': 'Planned paths have been deactivated',
		'PATH_PLANNINGS.DELETE.FAILURE': 'Some of the planned paths could not be deleted',
		'PATH_PLANNINGS.DELETE.QUESTION': 'Do you really want to delete the planned path?',
		'PATH_PLANNINGS.DELETE.SUCCESS': 'Planned paths deleted successfully',
		'PATH_PLANNINGS.MANAGEMENT': 'Planned paths management',
		'PATH_PLANNINGS.NOT_SELECTED': 'No planned path selected',
		'PATH_PLANNINGS.REACTIVATE.FAILURE': 'Some of the planned paths could not be reactivated',
		'PATH_PLANNINGS.REACTIVATE.QUESTION': 'Do you really want to reactivate the selected planned paths?',
		'PATH_PLANNINGS.REACTIVATE.SUCCESS': 'Planned paths reactivated successfully',
		'PATTERN': 'Pattern',
		'PATTERN.END_AT_ENTRANCE': 'End at entrance',
		'PATTERN.START': 'Pattern start/end',
		'PATTERN.START_AT_ENTRANCE': 'Start at entrance',
		'PAUSE': 'Pause',
		'PERFORMANCE.AVERAGE': 'Desempenho médio',
		'PERFORMANCE.AVERAGE.EXPLAINATION': 'Esse valor também leva em conta todos os estados de trabalho, incluindo os tempos de preparação e de estrada',
		'PERFORMANCE.AVERAGE.FIELD': 'Desempenho médio (campo)',
		'PERFORMANCE.AVERAGE.FIELD.EXPLAINATION': 'Esse valor leva em conta apenas o trabalho em um campo, a espera em um campo e a ativação de um campo',
		'PERFORMANCE.TOTAL': 'Desempenho total',
		'PHONE': 'Telefone',
		'PHONE.INVALID': 'Telefone inválido',
		'PHONE_MOBILE': 'Telefone (Celular)',
		'PH_VALUE': 'Valor de PH',
		'PLAY': 'Play',
		'POSTCODE': 'CEP',
		'PREVIOUS': 'Anterior',
		'PROCESS': 'Processos',
		'PROCESSED': 'Processado',
		'PROCESSED.FAILURE': 'Falha durante o processamento',
		'PROCESSED.SUCCESSFULL': 'Processado com sucesso',
		'PRODUCT': 'Produto',
		'PROGRESS': 'Progresso',
		'PROJECTION': 'Projeção',
		'RAW_DATA': 'Dados brutos',
		'RECEIVED.AT': 'Recebido em',
		'REGENERATE': 'Regenerar',
		'REGENERATE.SELECTED': 'Regenerar selecionado',
		'REGISTER': 'Cadastro',
		'REGISTER.ALREADY_REGISTERED?': 'Já possui uma conta?',
		'REGISTER.I_ACCEPT_THE': 'Eu aceito o',
		'RELOAD': 'Recarregar',
		'REMOVE': 'Remover',
		'RENEW': 'Renovar',
		'REOCURRING': 'Recorrente',
		'REPORT': 'Informe',
		'RESET': 'Reiniciar',
		'RESOLUTION': 'Resolução',
		'RESTORE.DRIVER': 'Restaurar o condutor',
		'RESTORE.IMPLEMENT': 'Restaurar a alfaia',
		'ROAD': 'Estrada',
		'ROLE': 'Função',
		'RUNTIME_H': 'Tempo de funcionamento em horas',
		'SAFETY_CHECK': 'Verificação de segurança',
		'SATELITE': 'Satélite',
		'SAVE': 'Salvar',
		'SCALE.TYPE': 'Tipo de escala',
		'SEARCH': 'Procurar veículos',
		'SEASON_YEAR': 'Ano de colheita',
		'SEASON_YEAR.START': 'Iniciar sessão',
		'SELECT.ALL': 'Selecionar tudo',
		'SELECT.CLEAR': 'Remover seleção',
		'SELECT.FIELD': 'Select field',
		'SENSORDATA': 'Dados do sensor',
		'SENSORDATA.DESCRIPTION': 'Gerar gráfico com os dados do sensor',
		'SENSORDATA.SELECT_SENSOR': 'Selecionar sensor',
		'SENSORDATA.SHOW_WORKSTATE_COLORS': 'Mostrar as cores do estado da obra',
		'SENSOR_PARAMETER': 'Parâmetro do sensor',
		'SENSOR_PARAMETER.ADD': 'Adicionar parâmetro do sensor',
		'SENSOR_PARAMETER.DEFINE_FOR_IMPLEMENT': 'Defina seu parâmetro individual do sensor para a alfaia selecionada',
		'SENSOR_PARAMETER.DEFINE_INDIVIDUAL_PARAM': 'Defina seu parâmetro individual do sensor',
		'SENSOR_PARAMETER.INDIVIDUAL_SENSOR_PARAM': 'Parâmetro individual do sensor',
		'SENSOR_PARAMETER.NOT_REMOVABLE_USED_IN_OTHER_PARAMETER': 'O parâmetro do sensor é utilizado em outra configuração de parâmetros',
		'SENSOR_PARAMETERS': 'Parâmetros do sensor',
		'SENSOR_PARAMETERS.NO': 'Nenhum parâmetro para o sensor',
		'SERIAL': 'Número de Série',
		'SETTINGS': 'Configurações',
		'SETTINGS.ADDITIONAL': 'Additional settings',
		'SETTINGS.ADVANCED': 'Advanced settings',
		'SETTINGS.AGRIROUTER_CAN_BE_CONNECTED': 'A sua conta Agrirouter pode ser conectada ao exatrek para compartilhar dados.',
		'SETTINGS.AGRIROUTER_CONNECTED_AND_READY': 'O Agrirouter está conectado e pronto. A ligação é válida até',
		'SETTINGS.CONNECTION_TO_PARTNERS': 'Conexão com parceiros da exatrek',
		'SETTINGS.FARMNET_FIELD_SYNC': 'Sincronizar campos da 365farmnet para a exatrek',
		'SETTINGS.FARMNET_IMPLEMENT_SYNC': 'Sincronizar alfaias do 365farmnet para Exatrek',
		'SETTINGS.FARMNET_MACHINE_SYNC': 'Sincronizar máquinas da exatrek para a 356farmnet',
		'SETTINGS.GO_TO_FARMNET': 'Ir para a 365FarmNet',
		'SETTINGS.ONLY_FARMNET_WEBAPP': 'As funções de sincronização \"de\" e \"para\" a 365farmnet só podem ser utilizados diretamente a partir do webapp 365farmnet.',
		'SHOW': 'Mostrar',
		'SHOW_DIRECTION': 'Mostrar direção',
		'SHOW_EVENTS': 'Mostrar eventos',
		'SHOW_FIELDS': 'Ver campo',
		'SHOW_LOCATIONS': 'Mostrar locais',
		'SHOW_OFFLINE_MACHINES': 'Veículos inativos',
		'SHOW_TRACKS': 'Pistas',
		'SHOW_TRACKS_': 'Pistas',
		'SNACKBAR.DAYS': 'dias',
		'SNACKBAR.LICENSE_EXPIRATION_WARNING': 'Sua licença expira em',
		'SNACKBAR.MACHINE_ONLINE_WARNING': 'Pelo menos uma máquina já não está em linha há algum tempo!',
		'SORT_BY': 'Classificar por',
		'SPEED': 'Velocidade',
		'SPEED.AVERAGE': 'Velocidade média',
		'SPEED.FASTER': 'Faster',
		'SPEED.RESET': 'Reset speed',
		'SPEED.SIGNAL.OVERRIDE': 'Anulação do aviso de velocidade',
		'SPEED.SLOWER': 'Slower',
		'SPEED.WORKING': 'Working speed',
		'SPLIT': 'Dividir',
		'START': 'Iniciar',
		'STATISTICS': 'Statistics',
		'STATUS': 'Estado',
		'STOP': 'Fim',
		'STORAGE': 'Armazenamento',
		'STORAGE.USB': 'Armazenamento USB',
		'STORAGE.USB.USED': 'Armazenamento USB usado',
		'STORAGE.USED': 'Armazenamento utilizado',
		'SYMBOLIZATION': 'Legenda',
		'TASK': 'Atividade',
		'TASK.ADDABLE_JOBS': 'Trabalhos adicionáveis',
		'TASK.ADD_JOBS': 'Adicionar viagens',
		'TASK.ARCHIVED_JOB_WARNING': 'Esta tarefa contém trabalhos arquivados e não será mostrada por completo!',
		'TASK.DELETE.JOB.FAILURE': 'Uma tarefa deve conter ao menos um trabalho!',
		'TASK.DELETE.JOB.QUESTION': 'Você realmente quer excluir este trabalho das tarefas?',
		'TASK.DELETE.JOB.SUCCESS': 'Trabalho excluído das tarefas com sucesso',
		'TASK.DELETE.QUESTION': 'Você realmente quer deletar a tarefa?',
		'TASK.DELETE.SUCCESS': 'Tarefa deletada com sucesso',
		'TASK.EDIT': 'Editar atividade',
		'TASK.EDIT.SUCCESS': 'Tarefa editada com sucesso',
		'TASK.EXPORT_DETAILS': 'Exportar a tarefa selecionada',
		'TASK.JOBS_TO_ADD': 'Viagens adicionadas',
		'TASK.NEW': 'Nova atividade',
		'TASKS': 'Tarefas',
		'TASKS.NO': 'Nenhuma tarefa',
		'TASK_CONTROLLER.ACTIVE': 'TaskController (DataLog) activo',
		'TASK_CONTROLLER.COMPAT_ACTIVE': 'TaskController modo de compatibilidade ativo',
		'TAX_ID': 'Número de identificação fiscal',
		'TC': 'Task Controller',
		'TC.ACTIVE': 'TC ativo',
		'TC.TC_COMP': 'TC comp',
		'TERMINAL.NO': 'Nenhum terminal',
		'TERMINAL.TYPE': 'Tipo de terminal',
		'TEST.SUCCESS': 'Conta de teste solicitada com sucesso. Em breve você receberá um e-mail.',
		'TIME': 'Horário',
		'TIME.REMAINING': 'Tempo restante',
		'TIMEZONE': 'Fuso horário',
		'TITLE': 'Solicitar conta de teste',
		'TOKEN': 'Código de acesso',
		'TOTAL': 'Total',
		'TRACKS.LOADING': 'Carregando pistas...',
		'TRACK.WIDTH': 'Largura da trilha',
		'TRACK.WIDTH.NARROW': 'Narrow',
		'TRACK.WIDTH.NORMAL': 'Normal',
		'TRACK.WIDTH.WIDE': 'Amplo',
		'TRACK_LENGTH': 'Comprimento da pista',
		'TRACK_REPLAY': 'Track replay',
		'TRANSLATABLE': 'Traduzível',
		'TRANSLATABLE.ADD': 'Adicionar traduzível',
		'TRANSLATION': 'Tradução',
		'TRANSPORT': 'Transporte',
		'TRANSPORT/AXLES': 'Transporte/Eixos',
		'TRANSPORTAMOUNT_AXLES': 'Quantidade de transporte/Eixos',
		'TURNINGS': 'Turnings',
		'TURNING_OFFSET': 'Turning offset',
		'TURNING_RADIUS': 'Turning radius',
		'TYPE': 'Tipo',
		'UNDO': 'Desfazer',
		'UNIT': 'Unidade',
		'UNKNOWN': 'Desconhecido',
		'UNTIL': 'até que',
		'UPLOAD': 'Carregar dados',
		'UPLOAD.FINISHED': 'Carregamento de dados concluído',
		'UPLOADING': 'Carregando dados',
		'USER.EDIT.SUCCESS': 'Usuário editado com sucesso',
		'USERNAME': 'Nome de usuário',
		'USERNAME.LENGTH.REQUIRED': 'O nome de usuário deve ter no mínimo 6 caracteres',
		'USERNAME.TAKEN': 'Este nome já está sendo utilizado.',
		'USERNAME.VALID.CHARS': 'O nome de usuário deve contar apenas letras, números, \"-\" e \"_\".',
		'USERROLE': 'Função do usuário',
		'USERSTATUS': 'Estado do usuário',
		'USER_CREATED': 'Usuário criado.',
		'WAITING': 'Aguardando',
		'WARNING': 'Advertência',
		'WEEK.CURRENT': 'Semana atual',
		'WEEK.NEXT': 'Próxima semana',
		'WEEK.PREVIOUS': 'Semana anterior',
		'WEEK.SELECTED': 'Semana selecionada',
		'WEIGHING': 'Pesagem',
		'WIDTH.INVALID': 'Largura inválida.',
		'WORKING_HOURS': 'Horas de trabalho',
		'WORKING_TIME': 'Tempo de trabalho',
		'WORKING_WIDTH': 'Largura de trabalho',
		'WORKSTATE': 'Estado do trabalho',
		'WORKSTATES': 'Estados de trabalho',
		'YES': 'Sim',
    'NO_POSITION_MACHINE_FOUND': 'Nenhuma posição encontrada para a máquina.',
	}
};
